const ta = {
  // ==================== Common Labels ====================
  fullname: "முழு பெயர்",
  firstName: "முதல் பெயர்",
  middleName: "நடுத்தர பெயர்",
  lastName: "கடைசி பெயர்",
  dateOfBirth: "பிறந்த தேதி",
  phoneNumber: "தொலைபேசி எண்",
  mobileNumber: "மொபைல் எண்",
  panNumber: "பான் எண்",
  searchName: "பெயரை தேடவும்",
  topicWisePerformance: "தலைப்பு வாரியான செயல்திறன் நுண்ணறிவு",
  strong: "வலுவான",
  weak: "பலவீனமான",
  category: "வகை",
  fromDate: "தொடக்க தேதி",
  toDate: "முடிவு தேதி",
  fromTime: "தொடக்க நேரம்",
  toTime: "முடிவு நேரம்",
  description: "விளக்கம்",
  subject: "பொருள்",
  name: "பெயர்",
  appliedDate: "விண்ணப்பித்த தேதி",
  staffType: "ஊழியர் வகை",
  allClass: "அனைத்து வகுப்புகள்",
  allSection: "அனைத்து பிரிவுகள்",
  allSchool: "அனைத்து பள்ளிகள்",
  allMembers: "அனைத்து உறுப்பினர்கள்",
  noFileChosen: "கோப்பு தேர்வு செய்யப்படவில்லை",
  chooseFile: "கோப்பை தேர்வு செய்",
  subjectList: "பாடப் பட்டியல்",
  subjectName: "பாடப் பெயர்",
  groupName: "குழு பெயர்",
  groupList: "குழு பட்டியல்",
  yes: "ஆம்",
  no: "இல்லை",
  empId: "[TRANSLATE]: Emp ID",
  email: "[TRANSLATE]: Email",
  mobileNo: "[TRANSLATE]: Mobile No",
  courses: "[TRANSLATE]: Courses",
  pageFrom: "[TRANSLATE]: Page From",
  pageTo: "[TRANSLATE]: Page To",
  dayScheduleListTitle: "[TRANSLATE]: Day Schedule List",
  classLabel: "வகுப்பு",
  sectionLabel: "பிரிவு",
  unit: "[TRANSLATE]: Units",
  chapter: "[TRANSLATE]: Chapter",
  shortDescription: "[TRANSLATE]: Short Description",
  class: "வகுப்பு",
  section: "பிரிவு",
  day: "[TRANSLATE]: Day",
  date: "தேதி",
  teacher: "ஆசிரியர்",
  total: "மொத்தம்",
  time: "நேரம்",
  action: "செயல்",
  batch: "தொகுதி",
  january: "ஜனவரி",
  february: "பிப்ரவரி",
  march: "மார்ச்",
  april: "ஏப்ரல்",
  may: "மே",
  june: "ஜூன்",
  july: "ஜூலை",
  august: "ஆகஸ்ட்",
  september: "செப்டம்பர்",
  october: "அக்டோபர்",
  november: "நவம்பர்",
  december: "டிசம்பர்",
  pincode: "அஞ்சல் குறியீடு",
  city: "நகரம்",
  country: "நாடு",
  state: "மாநிலம்",
  searchEmail: "மின்னஞ்சல் தேடுக",
  searchClass: "வகுப்பு தேடுக",
  searchSection: "பிரிவு தேடுக",
  searchGender: "பாலினம் தேடுக",
  startDate: "தொடக்க தேதி",
  endDate: "முடிவு தேதி",
  includeSubject: "பாடத்தை சேர்க்கவும்",
  durationHrs: "கால அளவு (மணி)",
  startTime: "தொடக்க நேரம்",
  endTime: "முடிவு நேரம்",
  duration: "கால அளவு",
  publishMarkList: "மதிப்பெண் பட்டியல் வெளியீடு",
  publishMarkView: "மதிப்பெண் பார்வை வெளியீடு",
  subjects: "பாடங்கள்",
  totalMark: "மொத்த மதிப்பெண்",
  rank: "தரவரிசை",
  dates: "தேதிகள்",
  votesPolled: "வாக்கெடுப்பு எண்ணிக்கை",
  publishView: "வெளியீடு பார்வை",
  staffLabel: "ஆசிரியர்",
  noteLabel: "குறிப்பு",
  messagingLabel: "செய்தி",
  birthdayDescription:
    "பிறந்தநாள்கள் சாதாரண நாட்கள் அல்ல 🎂 🎁 🎊 🎉 கொண்டாடுங்கள் – அது ஒருவர் வெளிச்சத்தையும் உலகத்தையும் தானாகவே கண்ட நாள் !! 🎈 👶 உங்கள் ஆசிரியர்கள், சக ஊழியர்கள் & நண்பர்களுக்கு அவர்களின் சிறப்பு நாளில் வாழ்த்துங்கள். 🤩",
  type: "வகை",
  completionDate: "நிறைவு தேதி",
  completionMonth: "நிறைவு மாதம்",
  medium: "மொழி வழி",
  totalCapacity: "மொத்த இடங்கள்",
  parent: "பெற்றோர்",
  eligibleForHigherStudies: "மேல்நிலை கல்விக்கு தகுதி",
  attachedDocumentType: "இணைக்கப்பட்ட ஆவணம் (மாற்றுச் சான்றிதழ் / பதிவு தாள்)",
  document: "ஆவணம்",
  classes: "வகுப்புகள்",
  place: "இடம்",
  resendOtp: "OTP மீண்டும் அனுப்பு",
  otpExpiresIn: "OTP காலாவதியாகும்",
  feedback: "கருத்து",
  group: "குழு",
  changeSectionOptional: "பிரிவு மாற்றம் (விருப்பத்தேர்வு)",
  feedbackRemarks: "கருத்து / குறிப்புகள்",
  totalPages: "மொத்தப் பக்கங்கள்",
  subjectMedium: "பாட மொழி",
  onAnyTopicToViewPages: "ஐ ஏதேனும் ஒரு தலைப்பில் கிளிக் செய்யவும்",
  scheduledDate: "திட்டமிடப்பட்ட தேதி",
  userName: "பயனர் பெயர்",
  updatedOn: "புதுப்பிக்கப்பட்ட தேதி",
  comments: "கருத்துக்கள்",
  schedule: "அட்டவணை",
  minPageShort: "குறைந்தபட்சம்",
  maxPageShort: "அதிகபட்சம்",
  startPageLabel: "தொடக்கப் பக்கம்",
  endPageLabel: "முடிவுப் பக்கம்",
  scheduleDate: "அட்டவணை தேதி",
  completedDate: "[TRANSLATE]: Completed Date",
  modalSuccessTitle: "வெற்றி",
  modalFailedTitle: "தோல்வி",
  andLabel: "மற்றும்",
  title: "தலைப்பு",
  createdDate: "உருவாக்கப்பட்ட தேதி",
  explanation: "விளக்கம்",
  submittedDate: "சமர்ப்பித்த தேதி",
  timeDurationMins: "நேர அளவு (நிமிடங்கள்)",
  generatingWithAi: "Gemini AI மூலம் உருவாக்கப்படுகிறது",
  copyPhoneAria: "தொலைபேசி எண்ணை நகலெடுக்கவும்",
  filterByClass: "வகுப்பின்படி வடிகட்டு",
  note: "குறிப்பு", // NEW
  confirm: "உறுதிப்படுத்து", // NEW
  filter: "வடிகட்டு", // NEW
  noData: "தரவு எதுவும் இல்லை", // NEW
  noOfAssessment: "மதிப்பீடுகளின் எண்ணிக்கை",
  totalStudent: "மொத்த மாணவர்கள்",
  showing: "காட்டுகிறது",
  to: "முதல்",
  of: "இல்",
  entries: "பதிவுகள்",

  // ==================== Menu / Navigation Labels ====================
  changePassword: "கடவுச்சொல்லை மாற்று",
  contentManagement: "உள்ளடக்க மேலாண்மை",
  profile: "சுயவிவரம்",
  logout: "வெளியேறு",
  lastLogin: "கடைசி உள்நுழைவு",
  dashboard: "டாஷ்போர்டு",
  campusHub: "வளாக மையம்",
  admission: "சேர்க்கை",
  birthday: "பிறந்தநாள்",
  workAnniversary: "பணி ஆண்டு விழா",
  capturePayment: "கட்டண பதிவு",
  admissionCycleConfig: "சேர்க்கை சுற்று அமைப்பு",
  admissionSeatAllocationConfig: "இட ஒதுக்கீடு அமைப்பு",
  admissionApplicationList: "சேர்க்கை விண்ணப்ப பட்டியல்",
  captureInterviewDetails: "நேர்காணல் விவரங்கள்",
  annualAcademicTransition: "வருடாந்திர கல்வி மாற்றம்",
  report: "அறிக்கை",
  studentReport: "மாணவர் அறிக்கை",
  attendanceReport: "வருகை அறிக்கை",
  timeTable: "நேர அட்டவணை",
  shift: "ஷிப்ட்",
  dayScheduleList: "நாள் அட்டவணை",
  timeTableView: "நேர அட்டவணை பார்வை",
  messaging: "செய்திகள்",
  messagingSms: "செய்தி உருவாக்கு",
  messagingEmail: "செய்தி நிர்வகிப்பு",
  events: "நிகழ்வுகள்",
  createEvent: "புதிய நிகழ்வு",
  eventCalendar: "நிகழ்வு காலண்டர்",
  master: "முதன்மை",
  academicConfiguration: "கல்வி அமைப்பு",
  staff: "பணியாளர்",
  holiday: "விடுமுறை",
  bulkUpload: "மொத்த பதிவேற்றம்",
  syllabus: "பாடத்திட்டம்",
  receiver: "பெறுநர்",
  botAttendance: "BOT வருகை",
  exam: "தேர்வு",
  examConfiguration: "தேர்வு அமைப்பு",
  examRules: "தேர்வு விதிகள்",
  examRule: "தேர்வு விதி",
  examSchedule: "தேர்வு அட்டவணை",
  examTimeTable: "தேர்வு நேர அட்டவணை",
  examResult: "தேர்வு முடிவுகள்",
  download: "பதிவிறக்கம்",
  applicationDetails: "விண்ணப்ப விவரங்கள்",
  attendanceDashboard: "வருகைப் பதிவு",
  aiAssistant: "ஏஐ உதவியாளர்",
  aiDashboard: "ஏஐ டாஷ்போர்டு",

  admissionConfig: "சேர்க்கை அமைப்பு",
  calendar: "காலண்டர்",
  notifications: "அறிவிப்புகள்",
  Subject: "பாடம்",
  Group: "குழு",
  lessonPlanApprove: "பாடத் திட்ட ஒப்புதல்",
  fees: "கட்டணம்",
  collectFees: "கட்டணம் வசூலிப்பு",
  paymentApproval: "கட்டண ஒப்புதல்",
  feeDashboard: "கட்டண டாஷ்போர்டு",
  dueFeeReport: "நிலுவை கட்டண அறிக்கை",
  discountReport: "தள்ளுபடி அறிக்கை",
  feesTransactionsReport: "கட்டண பரிவர்த்தனை அறிக்கை",
  settings: "அமைப்புகள்",
  schoolDetails: "பள்ளி விவரங்கள்",
  manageAttendance: "வருகை நிர்வகிப்பு",
  monthlyAttendanceReport: "மாதாந்திர வருகை அறிக்கை",
  createMessage: "செய்தி உருவாக்கு",
  manageMessages: "செய்திகளை நிர்வகிக்கவும்",
  event: "நிகழ்வு",
  students: "மாணவர்",
  syllabus_submission: "பாடத்திட்ட சமர்ப்பணம்",
  examTimetable: "தேர்வு நேர அட்டவணை",
  examMarksEntry: "தேர்வு மதிப்பெண் பதிவு",
  examResults: "தேர்வு முடிவுகள்",
  publishMarks: "மதிப்பெண்களை வெளியிடு",
  timetable: "நேர அட்டவணை",
  assignment: "ஏஐ உதவியாளர்",
  LessonPlan: "பாடத் திட்டம்",
  studyHub: "படிப்பு மையம்",
  payFees: "கட்டணம் செலுத்து",

  // ==================== Settings Page Labels ====================
  feeModuleQr: "கட்டண தொகுதி QR",
  aiModuleKey: "ஏஐ தொகுதி ஏஐ கீ",
  feeModuleQrRequired: "கட்டண தொகுதி QR தேவை",
  aiModuleKeyRequired: "ஏஐ தொகுதி ஏஐ கீ தேவை",
  feeModuleQrSavedSuccess: "கட்டண தொகுதி QR வெற்றிகரமாக சேமிக்கப்பட்டது!",
  aiModuleKeySavedSuccess: "ஏஐ தொகுதி ஏஐ கீ வெற்றிகரமாக சேமிக்கப்பட்டது!",

  // Plan / add-on gating
  feeModuleAddonRequired:
    "கட்டண தொகுதி கூடுதல் சேவையை வாங்கினால் மட்டுமே இந்த வசதியைப் பயன்படுத்த முடியும்.",
  aiPlanRequired:
    "ஏஐ திட்டத்தை வாங்கினால் மட்டுமே இந்த வசதியைப் பயன்படுத்த முடியும்.",

  // Status chips
  configured: "அமைக்கப்பட்டது",
  notConfigured: "அமைக்கப்படவில்லை",

  // Bank QR card
  bankName: "வங்கியின் பெயர்",
  qrCodeImage: "QR குறியீட்டு படம் (PNG, JPEG)",
  addQrCode: "QR குறியீட்டைச் சேர்",
  newQrPreview: "புதிய QR முன்னோட்டம்",
  currentQr: "தற்போதைய QR",
  noQrConfigured:
    "வங்கி QR குறியீடு இதுவரை அமைக்கப்படவில்லை. பெற்றோர் ஸ்கேன் செய்து கட்டணம் செலுத்த ஒன்றைச் சேர்க்கவும்.",
  qrHelperNote: "ஆதரிக்கப்படும் வடிவங்கள்: PNG, JPG, JPEG. அதிகபட்ச அளவு 2MB.",
  bankNameRequired: "வங்கியின் பெயர் தேவை",
  qrImageRequired: "QR குறியீட்டு படம் தேவை",
  qrImageSizeError: "QR படத்தின் அளவு 2MB-க்கு மேல் இருக்கக்கூடாது",
  deleteQrConfirm: "வங்கி QR குறியீடு கட்டண தொகுதியிலிருந்து நீக்கப்படும்.",

  // AI key card
  aiKeyConfiguration: "ஏஐ கீ அமைப்பு",
  aiName: "ஏஐ பெயர்",
  apiKey: "ஏபிஐ கீ",
  addAiKey: "ஏஐ கீ சேர்",
  noAiConfigured:
    "ஏஐ கீ இதுவரை அமைக்கப்படவில்லை. ஏஐ வசதிகள் (புத்தகம் சேர், பாடத் திட்டம், மதிப்பீடு, நிவாரணப் பயிற்சி, படிப்புப் பொருள்) இயல்புநிலை கீயைப் பயன்படுத்தும்.",
  aiKeyKeepNote:
    "தற்போது சேமிக்கப்பட்ட கீயை அப்படியே வைத்திருக்க ஏபிஐ கீ புலத்தை காலியாக விடவும்.",
  aiDescriptionPlaceholder:
    "ஏஐ சார்ந்த கல்வி வசதிகளுக்கான Gemini ஏஐ ஏபிஐ கீ அமைப்பு.",
  aiNameRequired: "ஏஐ பெயர் தேவை",
  aiKeyRequired: "ஏபிஐ கீ தேவை",
  deleteAiConfirm: "நீக்கிய பிறகு ஏஐ வசதிகள் இயல்புநிலை கீக்கு மாறும்.",

  // ==================== Password Labels ====================
  oldPassword: "பழைய கடவுச்சொல்",
  newPassword: "புதிய கடவுச்சொல்",
  retypeNewPassword: "புதிய கடவுச்சொல்லை உறுதிப்படுத்தவும்",
  updatePassword: "கடவுச்சொல்லை புதுப்பிக்கவும்",

  // ==================== Profile Labels ====================
  profilePhoto: "சுயவிவர புகைப்படம்",
  profileSetup: "சுயவிவர அமைப்பு",
  changeLanguage: "மொழி மாற்றம்",
  maritalStatus: "திருமண நிலை",
  single: "திருமணமாகாதவர்",
  married: "திருமணமானவர்",
  spouseName: "வாழ்க்கைத்துணை பெயர்",
  personalInfo: "தனிப்பட்ட தகவல்",
  locationBackground: "இடம் & பின்னணி",
  spiritualIdentification: "ஆன்மீகம் & அடையாளம்",
  profileTitle: "சுயவிவரம்",

  // ==================== Academic Labels ====================
  startYear: "தொடக்க ஆண்டு",
  endYear: "முடிவு ஆண்டு",
  academicYear: "கல்வி ஆண்டு",
  isUpcomingYear: "இது வரவிருக்கும் ஆண்டா?",

  // ==================== Messaging Labels ====================
  managementTalk: "மேலாண்மை உரை",
  message: "செய்தி",
  attachment: "இணைப்பு",
  role: "பங்கு",
  inbox: "உள்வரும் செய்திகள்",
  sentItems: "அனுப்பிய செய்திகள்",
  selectMessageToViewDetails: "விவரங்களை காண ஒரு செய்தியை தேர்வு செய்யவும்",
  staffAccount: "ஊழியர் கணக்கு",
  studentAccount: "மாணவர் கணக்கு",
  parentAccount: "பெற்றோர் கணக்கு",
  schoolCockpit: "பள்ளி காக்பிட்",
  allStaff: "அனைத்து ஊழியர்கள்",
  teaching: "கற்பித்தல்",
  administrative: "நிர்வாகம்",
  management: "மேலாண்மை",
  hallOfFameEmptyMessage:
    "வெற்றியாளர்களை அறிவிக்கவும் 🏆 மற்றும் உங்கள் 🤓 👨‍🎓 மாணவர்கள் & ஆசிரியர்களின் வெற்றிகளை இங்கே கொண்டாடுங்கள்... அங்கீகாரம் ஊக்க சக்தியாக செயல்படுகிறது 💪 😊",
  managementTalkEmptyMessage:
    "நிர்வாகத்தின் தொலைநோக்கு மற்றும் இலக்குகளை 🤩 இந்த இடத்தில் பகிர்ந்து உங்கள் நிறுவனம் இலக்குகளை அடையவும் புதிய உயரங்களை எட்டவும் உதவுங்கள் 🤞 🧑 👍",
  opinionPollEmptyMessage:
    '"மாணவர்கள் தேசத்தின் தூண்கள்" என்று சொல்வார்கள். பல்வேறு தலைப்புகளில் தங்கள் கருத்தை 🤓 👆 தெரிவிக்க அவர்களுக்கு உதவுங்கள், எங்கள் கருத்துக் கணிப்பு மூலையில் 🤟 😀',
  newsBlogsEmptyMessage:
    "உங்கள் பங்குதாரர்களை – மாணவர்கள், பெற்றோர், ஆசிரியர்கள் & ஊழியர்களை தீவிரமாக ஈடுபடுத்துங்கள் & கல்வி அளியுங்கள் மற்றும் தொடர்புடைய தலைப்புகளில் அர்த்தமுள்ள விவாதத்தை ஊக்குவிக்கவும் ☝️ 🤪",
  enterOtpSentToEmail:
    "உங்கள் மின்னஞ்சலுக்கு அனுப்பப்பட்ட 6 இலக்க OTP ஐ உள்ளிடவும்",

  // ==================== Event Labels ====================
  school: "பள்ளி",
  venue: "நிகழ்வு இடம்",

  // ==================== Content Management Labels ====================
  hallOfFame: "புகழ் மண்டபம்",
  newsAndBlogs: "செய்திகள் மற்றும் வலைப்பதிவுகள்",
  announcements: "அறிவிப்புகள்",
  opinionPoll: "கருத்துக் கணிப்பு",
  famePhoto: "புகழ் புகைப்படம்",
  content: "உள்ளடக்கம்",
  enter: "உள்ளிடு",
  designation: "பதவி",
  topicName: "தலைப்பு பெயர்",

  // ==================== Student Labels ====================
  emailAddress: "மின்னஞ்சல் முகவரி",
  male: "ஆண்",
  female: "பெண்",
  other: "மற்றவை",
  fatherName: "தந்தை பெயர்",
  motherName: "தாய் பெயர்",
  aadhaarNumber: "ஆதார் எண்",
  allStudents: "அனைத்து மாணவர்கள்",
  studentName: "மாணவர் பெயர்",
  studentId: "மாணவர் எண்",
  totalStudents: "மொத்த மாணவர்கள்",
  location: "இடம்",
  address: "முகவரி",
  district: "மாவட்டம்",
  geographicCoordinates: "புவியியல் இணை",
  cityTownVillage: "நகரம் / பேரூராட்சி / கிராமம்",
  student: "மாணவர்",
  emergencyContactNumber1: "அவசர தொடர்பு எண் 1",
  emergencyContactNumber2: "அவசர தொடர்பு எண் 2",
  familyDoctor: "குடும்ப மருத்துவர்",
  rollId: "ரோல் எண்",
  aadharNumber: "ஆதார் எண்",
  gender: "பாலினம்",
  religion: "மதம்",
  bloodGroup: "இரத்த வகை",
  medicalCondition: "மருத்துவ நிலை",
  studentPhoto: "மாணவர் புகைப்படம்",
  anniversary: "திருமண நாள்",
  address1: "முகவரி 1",
  address2: "முகவரி 2",
  address3: "முகவரி 3",
  occupation: "வேலை/தொழில்",
  income: "வருமானம்",
  relationType: "உறவு வகை",
  hospital: "மருத்துவமனை",
  studentList: "மாணவர் பட்டியல்",
  searchStudentId: "மாணவர் எண் தேடுக",
  searchStudentName: "மாணவர் பெயர் தேடுக",
  searchBloodGroup: "இரத்த வகை தேடுக",
  studentsPassed: "தேர்ச்சி பெற்ற மாணவர்கள்",
  workAnniversaryDescription:
    '"அனுபவம் ஒரு சிறந்த ஆசிரியர்" என்று சொல்வார்கள்... 👆 📝 உங்கள் ஆசிரியர்கள் & ஊழியர்களுக்கு அவர்களின் பணி ஆண்டு விழாவில் வாழ்த்துங்கள், அவர்களும் அனுபவத்தால் அறிவுடையவர்களாக வளர்கிறார்கள்... 🧑 🧔 👨‍🦰',
  studentPassed: "தேர்ச்சி பெற்ற மாணவர்கள்",
  studentImage: "மாணவர் படம்",
  studentsList: "மாணவர் பட்டியல்",

  // ==================== Admission Labels ====================
  admissionInterviewSchedule: "சேர்க்கை நேர்காணல் அட்டவணை",
  interviewSchedule: "நேர்காணல் அட்டவணை",
  seatAllocationApplication: "இருக்கை ஒதுக்கப்பட்ட விண்ணப்ப பட்டியல்",
  applicationId: "விண்ணப்ப ஐடி",
  backAdmissionApplicationList:
    "[TRANSLATE]: Back to Admission Application List",
  totalPromoted: "மொத்தம் பதவி உயர்வு",
  totalDetained: "மொத்தம் தடுத்து நிறுத்தப்பட்டது",
  publishAnnualTransition: "வருடாந்திர மாற்றத்தை வெளியிடு",
  updatePromotionStatus: "பதவி உயர்வு நிலையைப் புதுப்பிக்கவும்",
  passFail: "தேர்ச்சி/தோல்வி",
  assignSection: "பிரிவு ஒதுக்கீடு",
  uploadNewOfflineApplicationFile:
    "[TRANSLATE]: upload New Offline Application File",
  isChildStayingWithGuardian: "குழந்தை பாதுகாவலருடன் தங்குகிறதா?",
  pleaseAttachMedicalCertificate: "மருத்துவச் சான்றிதழை இணைக்கவும்",
  admissionName: "சேர்க்கை பெயர்",
  admissionType: "சேர்க்கை வகை",
  admissionStartDate: "சேர்க்கை தொடக்க தேதி",
  admissionEndDate: "சேர்க்கை முடிவு தேதி",
  screeningStartDate: "திரையிடல் தொடக்க தேதி",
  screeningEndDate: "திரையிடல் முடிவு தேதி",
  interviewStartDate: "நேர்காணல் தொடக்க தேதி",
  interviewEndDate: "நேர்காணல் முடிவு தேதி",
  seatAllocationConfiguration: "இட ஒதுக்கீடு அமைப்பு",
  searchSeatConfig: "தேடு ...",
  studentNameTamil: "மாணவர் பெயர் (தமிழ்)",
  studentNameEnglish: "மாணவர் பெயர் (ஆங்கிலம்)",
  dobInWords: "பிறந்த தேதி வார்த்தைகளில்",
  caste: "சாதி",
  nationality: "தேசியம்",
  areYouResidingWith: "பெற்றோர் அல்லது பாதுகாவலருடன் வசிக்கிறீர்களா?",
  guardian: "பாதுகாவலர்",
  annualIncome: "வருடாந்திர வருமானம்",
  lastStudiedDetails: "கடைசியாக படித்த விவரங்கள்",
  lastStudiedClass: "கடைசியாக படித்த வகுப்பு",
  lastStudiedSchool: "கடைசியாக படித்த பள்ளி",
  lastStudiedMedium: "கடைசியாக படித்த மொழி வழி",
  emisNo: "EMIS எண்",
  preferredCourseDetails: "விருப்பமான பாடப்பிரிவு விவரங்கள்",
  preferredClassForAdmission: "சேர்க்கைக்கான விருப்பமான வகுப்பு",
  motherTongue: "தாய்மொழி",
  preferredFirstLanguageToStudy: "படிக்க விரும்பும் முதல் மொழி",
  preferredMediumToStudy: "படிக்க விரும்பும் மொழி வழி",
  smallpoxVaccinationTaken: "அம்மை தடுப்பூசி போடப்பட்டதா?",
  previousSchoolAddress: "முந்தைய பள்ளி முகவரி",
  schoolName: "பள்ளி பெயர்",
  yearOfStudy: "படிப்பு ஆண்டு",
  mediumOfInstruction: "கற்பித்தல் மொழி வழி",
  identificationMarksOnBody: "உடலில் உள்ள அடையாளக் குறிகள்",
  identificationMark1: "அடையாளக் குறி 1",
  identificationMark2: "அடையாளக் குறி 2",
  admissionApplicationForm: "சேர்க்கை விண்ணப்பப் படிவம்",
  applicationPreview: "விண்ணப்ப முன்னோட்டம்",
  formXItoXII: "படிவம் - XI முதல் XII",
  formItoX: "படிவம் - I முதல் X வரை",
  birthPlace: "பிறந்த இடம்",
  communityCertificate: "சமுதாய சான்றிதழ்",
  preferredStudyCourse: "படிக்க விரும்பும் பாடப்பிரிவு",
  yearOfAdmission: "சேர்க்கை ஆண்டு (முதல் ஆண்டு / இரண்டாம் ஆண்டு)",
  firstYear: "முதல் ஆண்டு",
  secondYear: "இரண்டாம் ஆண்டு",
  preferredGroup1: "விரும்பிய குழு 1",
  preferredGroup2: "விரும்பிய குழு 2",
  preferredGroup3: "விரும்பிய குழு 3",
  mediumOfInstructionLeavingSchool: "பள்ளி விட்ட நேரத்தில் கற்பித்தல் மொழி வழி",
  studiedYear: "படிப்பு ஆண்டு",
  nccNssScoutsGuides:
    "NCC / NSS / ஸ்கவுட்ஸ் / கைட்ஸ் / ரெட் க்ராஸ் – சேர விரும்புகிறீர்களா?",
  certificatesForCoCurricular: "இணை பாடப்பிரிவு சான்றிதழ்கள்",
  taluk: "வட்டம்",
  secondaryVItoIX: "இரண்டாம் நிலை – VI முதல் IX வரை",
  higherSecondaryXI: "மேல்நிலை – XI",
  checklist: "சரிபார்ப்பு பட்டியல்",
  secondaryOnlineApplication: "இரண்டாம் நிலை ஆன்லைன் விண்ணப்பம்",
  tamilKeyboard: "தமிழ் விசைப்பலகை",
  withParents: "பெற்றோருடன்",
  withGuardian: "காப்பாளருடன்",
  documentToBeUploaded: "பதிவேற்ற வேண்டிய ஆவணம்",
  studentMotherTongue: "மாணவர் தாய்மொழி",
  preferredMediumOfInstruction: "விருப்பமான கற்பித்தல் மொழி",
  assignedGroup: "ஒதுக்கப்பட்ட குழு",
  preferredGroup: "விரும்பிய குழு",
  higherSecondaryOnlineApplication: "மேல்நிலை ஆன்லைன் விண்ணப்பம்",
  higherSecondaryApplication: "மேல்நிலை விண்ணப்பம்",
  assignedClass: "ஒதுக்கப்பட்ட வகுப்பு",
  assignedSection: "ஒதுக்கப்பட்ட பிரிவு",
  checkList: "சரிபார்ப்பு பட்டியல்",
  checklistItems: "சரிபார்ப்பு பட்டியல் உருப்படிகள்",

  // ==================== Exam / Assessment Labels ====================
  markSheet: "மதிப்பெண் பட்டியல்",
  predictedScore: "எதிர்பார்க்கப்படும் மதிப்பெண்",
  actualScore: "உண்மையான மதிப்பெண்",
  examTypePlaceholde: "[TRANSLATE]: Select Exam Type",
  examType: "தேர்வு வகை",
  examName: "தேர்வு பெயர்",
  allExams: "அனைத்து தேர்வுகள்",
  isAnnualExam: "இது வருடாந்திர தேர்வா?",
  examPassRules: "தேர்வு தேர்ச்சி விதிகள்",
  theory: "தியரி",
  practical: "பிராக்டிகல்",
  examMode: "தேர்வு முறை",
  dateOfExam: "தேர்வு தேதி",
  passMark: "தேர்ச்சி மதிப்பெண்",
  maximumMark: "அதிகபட்ச மதிப்பெண்",
  examScheduleList: "தேர்வு அட்டவணை பட்டியல்",
  modeOfExam: "தேர்வு முறை",
  maxMark: "அதிகபட்ச மதிப்பெண்",
  selectExamAndClass: "நேர அட்டவணையைக் காண தேர்வுப் பெயரைத் தேர்ந்தெடுக்கவும்",
  markBulkUpload: "மதிப்பெண் மொத்த பதிவேற்றம்",
  passedPercentage: "தேர்ச்சி சதவீதம்",
  failedPercentage: "தோல்வி சதவீதம்",
  passesdPercentage: "[TRANSLATE]: Passed Percentage",
  qualifyingExaminationPassed: "தகுதித் தேர்வு தேர்ச்சி",
  nameOfExaminationBoard: "தேர்வு வாரியத்தின் பெயர்",
  publicExaminationMarks: "பொது தேர்வு மதிப்பெண்கள்",
  nameOfExaminationPassed: "தேர்ச்சி பெற்ற தேர்வின் பெயர்",
  monthAndYearOfExamination: "தேர்வு மாதம் மற்றும் ஆண்டு",
  examinationRegisterNumber: "தேர்வு பதிவு எண்",
  marksObtained: "பெற்ற மதிப்பெண்",
  maxMarks: "அதிகபட்ச மதிப்பெண்",
  overall: "மொத்தம்",
  percentage: "சதவீதம்",
  subjectWiseScorePrediction: "[TRANSLATE]: Subject wise Score Prediction",
  assessment: "மதிப்பீடு",
  remedialAssessment: "பரிகார மதிப்பீடு",
  questionsCount: "கேள்விகள் எண்ணிக்கை",
  questionCount: "கேள்வி எண்ணிக்கை",
  difficultyLevel: "சிரம நிலை",
  mcqOptionsCount: "MCQ விருப்பங்கள் எண்ணிக்கை",
  passPercentage: "தேர்ச்சி சதவீதம்",
  previewAssessment: "மதிப்பீட்டு முன்னோட்டம்",
  failedToGenerateAssessment: "மதிப்பீட்டை உருவாக்க முடியவில்லை",
  failedToSaveAssessment: "மதிப்பீட்டை சேமிக்க முடியவில்லை",
  numberOfQuestion: "கேள்வி எண்ணிக்கை",
  academicHealthScore: "கல்வி ஆரோக்கியம் மதிப்பெண்",
  assessmentProgressTracker: "மதிப்பீட்டு முன்னேற்ற கண்காணிப்பு",
  classAverageEngagementScore: "வகுப்பு சராசரி ஈடுபாட்டு மதிப்பெண்",
  subjectWiseEngagementScore: "பாட வாரியான ஈடுபாட்டு மதிப்பெண்",
  engagementScore: "ஈடுபாட்டு மதிப்பெண்",
  myScore: "என் மதிப்பெண்",
  classTopperScore: "வகுப்பு உச்ச மதிப்பெண்",

  // ==================== Attendance Labels ====================
  workingDays: "வேலை நாட்கள்",
  attendance: "வருகைப் பதிவு",
  attendanceList: "வருகை பட்டியல்",
  studentAttendanceMonthlyView: "மாணவர் வருகை மாதாந்திர பார்வை",
  attendancePercentage: "வருகை(%)",
  classStrength: "வகுப்பு பலம்",
  totalWorkingDaysYear: "மொத்த வேலை நாட்கள் (ஆண்டு)",
  totalPresentYear: "மொத்த வருகை (ஆண்டு)",
  totalAbsentYear: "மொத்த வராதது (ஆண்டு)",
  attendancePercentageYear: "வருகை சதவீதம் (ஆண்டு)",
  totalWorkingDaysMonth: "மொத்த வேலை நாட்கள் (மாதம்)",
  totalPresentMonth: "மொத்த வருகை (மாதம்)",
  totalAbsentMonth: "மொத்த வராதது (மாதம்)",
  attendancePercentageMonth: "வருகை சதவீதம் (மாதம்)",
  todayDate: "இன்றைய தேதி",
  today: "இன்று",
  calendarMonth: "மாதம்",
  calendarWeek: "வாரம்",
  calendarDay: "நாள்",
  studentAttendanceDashboard: "மாணவர் வருகை டாஷ்போர்டு",
  staffAttendanceDashboard: "பணியாளர் வருகைப் பதிவேடு டாஷ்போர்டு",
  attendanceLogs: "வருகை பதிவுகள்",
  attendanceRate: "வருகை விகிதம்",
  dailyAttendance: "தினசரி வருகை",
  todayAbsentee: "இன்றைய வராதவர்கள்",
  classAttendanceTrend: "வகுப்பு வருகை போக்கு",
  assessmentTrend: "மதிப்பீட்டுப் போக்கு",
  studentAttendanceTrend: "மாணவர் வருகை போக்கு",
  teacherAttendanceTrend: "ஆசிரியர் வருகை போக்கு",

  // ==================== Leave Labels ====================
  leaveList: "விடுப்பு பட்டியல்",
  leaveCreate: "விடுப்பு விண்ணப்பம்",
  noOfDaysLeave: "நாட்கள் எண்ணிக்கை",
  reason: "காரணம்",
  leaveRequest: "விடுப்பு கோரிக்கை",
  child: "குழந்தை",
  sickLeave: "உடல்நலக் குறைவு விடுப்பு",
  fever: "காய்ச்சல்",
  familyFunction: "குடும்ப நிகழ்வு",
  medical: "மருத்துவம்",
  personal: "தனிப்பட்டது",
  others: "மற்றவை",
  classTeacherRemark: "வகுப்பு ஆசிரியர் கருத்து",
  reasonForWithdraw: "திரும்பப் பெற காரணம்",
  reasonForLeaving: "பள்ளி விட்ட அல்லது இடைநிறுத்திய காரணம்",

  // ==================== Holiday Labels ====================
  holidayType: "விடுமுறை வகை",
  searchHolidayType: "விடுமுறை வகை தேடுக",

  // ==================== Shift / Timetable Labels ====================
  shiftConfigurationList: "[TRANSLATE]: Shift Configure List",
  shiftLabel: "பணி நேரம்",
  shift1: "[TRANSLATE]: SHIFT 1",
  shift2: "[TRANSLATE]: SHIFT 2",
  period: "பீரியட்",
  periodSubject: "[TRANSLATE]: Period Subject",
  shiftName: "ஷிப்ட் பெயர்",
  numberOfBreaks: "இடைவேளைகள் எண்ணிக்கை",
  numberOfPeriods: "பீரியட்கள் எண்ணிக்கை",
  breakType: "இடைவேளை வகை",
  periodName: "பீரியட் பெயர்",
  break: "இடைவேளை",

  // ==================== Book Labels ====================
  book: "புத்தகம்",
  bookList: "புத்தகப் பட்டியல்",
  term: "பருவம்",
  volume: "தொகுதி",
  topic: "தலைப்பு",
  subTopic: "உட்தலைப்பு",
  start: "தொடக்கம்",
  end: "முடிவு",
  bookPages: "புத்தகப் பக்கங்கள்",
  pdfPages: "PDF பக்கங்கள்",
  clickEyeIconToView: "இங்கே பக்கங்களைப் பார்க்க",
  eyeIcon: "கண் ஐகான்",
  page: "பக்கம்",
  bookDetails: "புத்தக விவரங்கள்",
  contentStartPage: "உள்ளடக்க தொடக்க பக்கம்",
  contentEndPage: "உள்ளடக்க முடிவு பக்கம்",
  bookFirstPageNo: "புத்தக முதல் பக்க எண்.",
  pdfPageOfBookFirstPageNo: "புத்தக முதல் பக்க PDF பக்க எண்.",
  printedPageOnFirstContentPage:
    "முதல் உள்ளடக்க பக்கத்தில் அச்சிடப்பட்ட பக்க எண்",
  openPdfInViewer:
    "PDF ஐ பார்வையாளரில் திறந்து, மேலே உள்ள எண் காட்டும் பக்கத்தைக் கண்டறிந்து, அந்த PDF பக்க எண்ணை உள்ளிடவும்",
  contentsPage: "உள்ளடக்க பக்கம்",

  // ==================== Lesson Plan Labels ====================
  examTimeTableList: "தேர்வு நேர அட்டவணை பட்டியல்",
  tabAll: "அனைத்தும்",
  tabSubmitted: "சமர்ப்பிக்கப்பட்டது",
  tabApproved: "அங்கீகரிக்கப்பட்டது",
  tabRejected: "நிராகரிக்கப்பட்டது",
  tabClasswise: "வகுப்பு வாரியாக",
  tabTeacherwise: "ஆசிரியர் வாரியாக",
  toggleAll: "அனைத்தும்",
  toggleThisWeek: "இந்த வாரம்",
  studyMaterial: "படிப்புப் பொருள்",
  savedLessonPlan: "சேமிக்கப்பட்ட பாடத் திட்டம்",
  lessonPlan: "பாடத் திட்டம்",
  breadcrumbSeparator: "/",
  breadcrumbAriaLabel: "வழிசெலுத்தல் பாதை",
  weeklyScheduleTitle: "வார அட்டவணை",
  scheduleGridEmpty: "அட்டவணையைக் காண தேதியைத் தேர்ந்தெடுக்கவும்",
  periodRoman: "காலம்",
  legendSubmitted: "சமர்ப்பிக்கப்பட்டது",
  legendApproved: "அங்கீகரிக்கப்பட்டது",
  legendRejected: "நிராகரிக்கப்பட்டது",
  legendResubmitted: "மீண்டும் சமர்ப்பிக்கப்பட்டது",
  cellEmpty: "---",
  lessonPlanEditorTitle: "பாடத் திட்டத் தொகுப்பி",
  bookPdfTitle: "புத்தக PDF",
  pdfFallbackMessage: "PDF இங்கே தோன்றும்",
  failedToSaveLessonPlan: "பாடத் திட்டத்தைச் சேமிக்க முடியவில்லை.",
  failedToGenerateLessonPlan: "பாடத் திட்டத்தை உருவாக்க முடியவில்லை.",
  socialScienceSample: "சமூக அறிவியல்",
  classSectionSample: "VI - A",
  lessonPeriodSlot1: "09:30 am - 10:15 am",
  lessonPeriodSlot2: "10:15 am - 11:00 am",
  lessonPeriodSlot3: "11:15 am - 12:00 pm",
  lessonPeriodSlot4: "12:00 pm - 12:45 pm",
  lessonPeriodSlot5: "01:30 pm - 02:15 pm",
  lessonPeriodSlot6: "02:15 pm - 03:00 pm",
  lessonPeriodSlot7: "03:15 pm - 04:00 pm",
  lessonPeriodSlot8: "04:00 pm - 04:45 pm",
  legendCompleted: "நிறைவு செய்யப்பட்டது",
  loadingTimetable: "கால அட்டவணை ஏற்றப்படுகிறது...",
  failedToScheduleLessonPlan: "பாடத் திட்டத்தை நிரப்ப முடியவில்லை",
  weeklyTimetable: "வார நேர அட்டவணை",
  studyMaterialAlreadyGenerated:
    "இந்த மாணவருக்கு ஏற்கனவே படிப்புப் பொருள் உருவாக்கப்பட்டுள்ளது",
  failedToDeleteStudyMaterial: "படிப்புப் பொருளை நீக்க முடியவில்லை",
  studyMaterialDeleted: "படிப்புப் பொருள் வெற்றிகரமாக நீக்கப்பட்டது",

  // ==================== Dashboard Labels ====================
  subjectEngagementRiskAnalysis: "பாட ஈடுபாட்டு ஆபத்து பகுப்பாய்வு",
  month: "மாதம்",
  staffDirectory: "ஊழியர் அடைவு",
  staffName: "ஊழியர் பெயர்",
  contact: "தொடர்பு",
  myChild: "என் குழந்தை",
  source: "ஆதாரம்",
  birthdayTitle: "பிறந்தநாள்!",
  workAnniversaryTitle: "பணி ஆண்டு விழா!",
  switchToStaffDashboard: "ஊழியர் டாஷ்போர்டுக்கு மாறு",
  switchToStudentDashboard: "மாணவர் டாஷ்போர்டுக்கு மாற்றவும்",
  performanceOverview: "செயல்திறன் கண்ணோட்டம்",
  dataset1: "தரவுத்தொகுப்பு 1",
  clickBarForSubjectBreakdown:
    "பாட வாரியான விவரத்தைக் காண எந்த பட்டியையும் கிளிக் செய்யவும்",
  subjectBreakdownClickXToGoBack:
    "பாட வாரியான விவரம் - திரும்ப செல்ல X ஐ கிளிக் செய்யவும்",
  assessmentTrendNote:
    "மாணவர் வாரியான மதிப்பீட்டு நிலையைக் காண ஒரு புள்ளியைக் கிளிக் செய்யவும்; சரியான மதிப்புகளுக்கு மேலே வைக்கவும்.",
  subjectWiseSuffix: "(பாட வாரியாக)",
  remedialProgressTracker: "பரிகார முன்னேற்ற கண்காணிப்பு",
  weekly: "வாரந்தோறும்",
  monthly: "மாதந்தோறும்",
  yearly: "ஆண்டுதோறும்",
  week: "வாரம்",
  year: "ஆண்டு",
  onTrackAlerts: "சரியான பாதையில் எச்சரிக்கைகள்",
  needsAttentionAlerts: "கவனம் தேவைப்படும் எச்சரிக்கைகள்",
  noAlerts: "காட்ட எச்சரிக்கைகள் இல்லை",
  syllabusCompletion: "பாடத்திட்ட நிறைவு சதவீதம்",
  totalTeachers: "மொத்த ஆசிரியர்கள்",
  classRanking: "வகுப்பு தரவரிசை",
  teacherRanking: "ஆசிரியர் தரவரிசை",
  academicHealthScoreInsights: "கல்வி ஆரோக்கிய மதிப்பெண் நுண்ணறிவுகள்",
  academicHealthNotes:
    "வரைபடத்தின் (Chart) எந்தப் பகுதியையும் கிளிக் செய்து, அந்த வகையில் உள்ள மாணவர்களைப் பார்க்கலாம். தேர்ந்தெடுக்கப்பட்ட பகுதியின் அடிப்படையில் மாணவர் பட்டியல் காட்டப்படும்.",
  // ==================== Report Labels ====================
  staffDefectList: "ஊழியர் குறைபாட்டு பட்டியல்",
  studentDefectList: "மாணவர் குறைபாட்டு பட்டியல்",
  defectList: "குறைபாட்டு பட்டியல்",

  // ==================== Table Labels ====================
  image: "படம்",
  rowsPerPage: "ஒரு பக்கத்தில் வரிகள்",
  noOfSection: "[TRANSLATE]: No. of Sections",
  fileName: "[TRANSLATE]: File Name",
  sizeKb: "[TRANSLATE]: Size(kb)",
  lastModified: "[TRANSLATE]: Last Modified",
  actions: "செயல்கள்",
  serialNo: "வரிசை எண்",
  noOfDays: "நாட்கள் எண்ணிக்கை",
  noOfBreak: "[TRANSLATE]: No. of Breaks",
  noOfPeriods: "[TRANSLATE]: No. of Periods",
  noOfMale: "ஆண் மாணவர்கள் எண்ணிக்கை",
  noOfFemale: "பெண் மாணவர்கள் எண்ணிக்கை",
  totalNoOfStudent: "மொத்த மாணவர்கள் எண்ணிக்கை",
  dayPeriodHeader: "[TRANSLATE]: Day / Period",
  actionHeader: "[TRANSLATE]: Action",

  // ==================== Form Labels ====================
  optional: "(விருப்பத்தேர்வு)",
  fatherInformation: "தந்தை தகவல்",
  motherInformation: "தாய் தகவல்",
  guardianInformation: "பாதுகாவலர் தகவல்",
  sameAddress: "(அதே முகவரி)",
  studentDetails: "மாணவர் விவரங்கள்",
  basicDetails: "அடிப்படை விவரங்கள்",
  residentialDetails: "குடியிருப்பு விவரங்கள்",
  otherDetails: "பிற விவரங்கள்",
  academicDetails: "கல்வி விவரங்கள்",
  marksTable: "மதிப்பெண் அட்டவணை",
  statusDetails: "நிலை விவரங்கள்",
  breakDetails: "இடைவேளை விவரங்கள்",
  periodDetails: "பீரியட் விவரங்கள்",
  tableOfContents: "பொருளடக்கம்",
  generatedTableOfContents: "உருவாக்கப்பட்ட பொருளடக்கம்",

  // ==================== Button / Action Labels ====================
  copy: "நகலெடு",
  readMoreLink: "மேலும் படிக்க",
  select: "தேர்வு செய்",
  retry: "மீண்டும் முயற்சி",
  send: "அனுப்பு",
  loading: "ஏற்றுகிறது...",
  cancel: "ரத்து செய்",
  submit: "சமர்ப்பி",
  update: "புதுப்பி",
  submitting: "சமர்ப்பிக்கிறது...",
  updating: "புதுப்பிக்கிறது...",
  uploadYourFile: "[TRANSLATE]: Upload your file here",
  downloadSampleFile: "[TRANSLATE]: DOWNLOAD THE SAMPLE FILE",
  import: "[TRANSLATE]: IMPORT",
  viewAction: "[TRANSLATE]: View",
  viewDayScheduleTitle: "[TRANSLATE]: Create Day Schedule",
  editDayScheduleTitle: "[TRANSLATE]: Edit Day Schedule",
  all: "அனைத்தும்",
  add: "சேர்க்க",
  edit: "திருத்து",
  back: "பின்செல்",
  adding: "சேர்க்கிறது...",
  delete: "நீக்கு",
  view: "பார்வை",
  save: "சேமிக்க",
  deleting: "நீக்குகிறது...",
  updateButton: "புதுப்பி",
  saving: "சேமிக்கிறது...",
  createButton: "உருவாக்கு",
  cancelButton: "ரத்து செய்",
  saveButton: "சேமிக்கவும்",
  searchButton: "தேடு",
  resetButton: "மீட்டமை",
  checkExamButton: "[TRANSLATE]: Check Exam",
  refreshButton: "[TRANSLATE]: Refresh",
  addSyllabus: "[TRANSLATE]: ADD SYLLABUS",
  clear: "அழி",
  downloadExcel: "எக்செல் பதிவிறக்கம்",
  editProfile: "சுயவிவரத்தைத் திருத்தவும்",
  backToProfile: "சுயவிவரத்திற்கு திரும்பு",
  saveProfile: "சுயவிவரத்தை சேமிக்கவும்",
  saveToDraft: "வரைவில் சேமி",
  addButton: "சேர்க்க",
  downloadButton: "பதிவிறக்கம்",
  viewStudent: "மாணவரைப் பார்க்க",
  createExamSchedule: "தேர்வு அட்டவணை உருவாக்குதல்",
  editExamSchedule: "தேர்வு அட்டவணையை திருத்துதல்",
  downloadFrameSet: "கட்டமைப்பு பதிவிறக்கம்",
  uploadFrameSet: "கட்டமைப்பு பதிவேற்றம்",
  uploading: "பதிவேற்றுகிறது...",
  uploadMarksheet: "மதிப்பெண் பட்டியலைப் பதிவேற்றவும்",
  publish: "வெளியிடு",
  createAttendance: "வருகை உருவாக்கு",
  editAttendance: "வருகை திருத்து",
  upload: "பதிவேற்றம்",
  approve: "ஒப்புதல்",
  reject: "நிராகரி",
  seeAll: "அனைத்தையும் காண",
  readFullSpeech: "முழு உரையைப் படிக்கவும்",
  verifyApplication: "விண்ணப்பத்தை சரிபார்க்கவும்",
  confirmAndSubmit: "உறுதிப்படுத்து & சமர்ப்பிக்கவும்",
  withdrawApplication: "விண்ணப்பத்தை திரும்பப் பெறவும்",
  offlineApplication: "+ ஆஃப்லைன் விண்ணப்பம்",
  allocateSeat: "இருக்கை ஒதுக்கு",
  moveToDropped: "நீக்கப்பட்டதாக மாற்று",
  bulkChangeStatus: "மொத்த நிலை மாற்றம்",
  proceed: "தொடரவும்",
  updateChanges: "மாற்றங்களைப் புதுப்பிக்கவும்",
  deletegroup: "குழுவை நீக்கு",
  approveApplication: "விண்ணப்பத்தை அங்கீகரிக்கவும்",
  rejectStudents: "மாணவர்களை நிராகரிக்கவும்",
  createShift: "ஷிப்ட் உருவாக்கு",
  editShift: "ஷிப்ட் திருத்து",
  deleteShift: "ஷிப்டை நீக்கவும்",
  viewBook: "புத்தகத்தைப் பார்",
  fullPdf: "முழு PDF",
  prev: "முந்தைய",
  next: "அடுத்து",
  addBook: "புத்தகம் சேர்",
  editBook: "[TRANSLATE]: Edit Book",
  generateTableOfContents: "பொருளடக்கத்தை உருவாக்கு",
  uploadBookPdf: "புத்தகத்தை பதிவேற்றவும் (PDF)",
  viewUploadedBook: "பதிவேற்றிய புத்தகத்தைப் பார்",
  backToAddBook: "புத்தகம் சேர் பக்கத்திற்கு திரும்பு",
  close: "மூடு",
  viewLessonPlan: "பாடத் திட்டத்தைப் பார்",
  createLessonPlan: "பாடத் திட்டத்தை உருவாக்கு",
  editLessonPlan: "பாடத் திட்டத்தைத் திருத்து",
  generatingLessonPlan: "உருவாக்குகிறது...",
  generateLessonPlan: "பாடத் திட்டத்தை உருவாக்கு",
  regenerateLessonPlan: "மீண்டும் உருவாக்கு",
  saveAsDraft: "வரைவாக சேமி",
  submitToHM: "HM-க்கு சமர்ப்பி",
  scheduleLessonPlan: "பாடத் திட்டத்தை நிரப்பு",
  viewAssessment: "மதிப்பீட்டை பார்",
  viewRemedialAssessment: "பரிகார மதிப்பீட்டை பார்",
  viewStudyMaterial: "படிப்புப் பொருளை பார்",
  generateAssessment: "மதிப்பீட்டை உருவாக்கு",
  generateremedialAssessment: "தீர்வு மதிப்பீட்டை உருவாக்கு",
  generating: "உருவாக்குகிறது...",
  generate: "உருவாக்கு",
  regenerate: "மீண்டும் உருவாக்கு",
  viewResult: "முடிவைப் பார்",
  createRemedialAssessment: "பரிகார மதிப்பீட்டை உருவாக்கு",
  createStudyMaterial: "படிப்புப் பொருளை உருவாக்கு",
  ok: "சரி",
  viewAll: "அனைத்தையும் பார்",

  // ==================== Status Labels ====================
  inviteStatus: "அழைப்பு நிலை",
  annualTransitionStatus: "வருடாந்திர மாற்றம் நிலை",
  TransitionCompleted: "மாற்றம் நிறைவடைந்தது",
  TransitionNotCompleted: "மாற்றம் நிறைவடையவில்லை",
  success: "வெற்றி",
  failed: "தோல்வி",
  status: "நிலை",
  present: "வருகை",
  absent: "வராதது",
  leave: "விடுப்பு",
  active: "செயலில்",
  inactive: "செயலற்றது",
  published: "வெளியிடப்பட்டது",
  verified: "சரிபார்க்கப்பட்டது",
  notVerified: "சரிபார்க்கப்படவில்லை",
  accepted: "ஏற்கப்பட்டது",
  rejected: "நிராகரிக்கப்பட்டது",
  withdrawn: "திரும்பப் பெறப்பட்டது",
  pending: "நிலுவையில்",
  submitted: "சமர்ப்பிக்கப்பட்டது",
  enrolled: "சேர்க்கை செய்யப்பட்டவர்",
  seatAllocated: "இருப்பிடம் ஒதுக்கப்பட்டது",
  approved: "அங்கீகரிக்கப்பட்டது",
  rejectedSmall: "நிராகரிக்கப்பட்டது",
  alreadySeatAllocated: "ஏற்கனவே இருக்கை ஒதுக்கப்பட்டது",
  currentStatus: "தற்போதைய நிலை",
  hold: "நிறுத்தி வைக்கவும்",
  updatedStatus: "புதுப்பிக்கப்பட்ட நிலை",
  resubmitted: "மீண்டும் சமர்ப்பிக்கப்பட்டது",
  completed: "முடிக்கப்பட்டது",
  draft: "வரைவு",
  statusApproved: "அங்கீகரிக்கப்பட்டது",
  statusCompleted: "முடிக்கப்பட்டது",
  pass: "தேர்ச்சி",
  fail: "தோல்வி",
  passed: "தேர்ச்சி",
  unattended: "கலந்துகொள்ளாதவை",

  // ==================== Modal / Dialog Labels ====================
  subjectEngagementNote:
    "இந்த வகையில் சேர்க்கப்பட்டுள்ள மாணவர்களைக் காண, விளக்கப்படத்தின் எந்தப் பகுதியையும் கிளிக் செய்யவும். தேர்ந்தெடுக்கப்பட்ட பகுதியின் அடிப்படையில் மாணவர் பட்டியல் காட்டப்படும்.",
  confirmDeleteSchedule: "இந்த அட்டவணையை நீக்க விரும்புகிறீர்களா?",
  confirmDeleteTimeTable: "இந்த நேர அட்டவணையை நீக்க விரும்புகிறீர்களா?",
  examConfigEditNote:
    "தேர்வு அட்டவணை ஏற்கனவே உருவாக்கப்பட்டுள்ளது. நிலையை திருத்த அனுமதி இல்லை.",
  confirmDelete: "நீங்கள் நிச்சயமாக நீக்க விரும்புகிறீர்களா?",
  examRulesNote:
    "தேர்ச்சி அளவுகோல்களை பூர்த்தி செய்யும் மாணவர்கள் மட்டுமே தரவரிசைக்கு தகுதியானவர்கள்.",
  toDateResetWarning:
    "முடிவு தேதி தொடக்க தேதிக்கு முன்பு இருந்ததால் மீட்டமைக்கப்பட்டது",
  parentGuardianAffidavit: "பெற்றோர் / பாதுகாவலர் உறுதிமொழி",
  iAgreeToAboveStatements:
    "மேற்கூறிய அறிக்கைகளை நான் படித்து ஒப்புக்கொள்கிறேன்.",
  affidavitLine1:
    "என் மகன்/மகள் பள்ளியின் விதிகள் மற்றும் ஒழுங்குமுறைகளை கண்டிப்பாக பின்பற்றுவார் என்று நான் உறுதியளிக்கிறேன்.",
  affidavitLine2:
    "எந்தவொரு தவறான நடத்தையின் போதும், இடமாற்றுச் சான்றிதழை கோரி பெற்றுக்கொள்ள ஒப்புக்கொள்கிறேன்.",
  affidavitLine3:
    "மேலே கொடுக்கப்பட்ட விவரங்கள் என் அறிவுக்கு எட்டிய வரை சரியானவை என்று சான்றளிக்கிறேன்.",
  affidavitLine4:
    '"முந்தைய பள்ளி முகவரி" என்ற பகுதியில் குறிப்பிடப்பட்ட பள்ளியைத் தவிர வேறு எந்தப் பள்ளியிலும் என் மகன்/மகள் சேர்ந்து படிக்கவில்லை என்று உறுதிப்படுத்துகிறேன்.',
  affidavitLine5:
    "இந்த சேர்க்கை விண்ணப்பத்தில் அளிக்கப்பட்ட பிறந்த தேதி மற்றும் சமுதாய விவரங்கள் உண்மையானவை மற்றும் சரியானவை என்று அறிவிக்கிறேன்.",
  affidavitLine6:
    "இந்த விவரங்களில் எந்த மாற்றத்திற்கும் விண்ணப்பிக்க மாட்டேன் என்று உறுதியளிக்கிறேன்.",
  publicMarksNote:
    "தகுதித் தேர்வில் பெற்ற மதிப்பெண்கள் கடைசியாக படித்த பள்ளியின் தலைமையாசிரியர் அல்லது அரசு அதிகாரியால் சரிபார்க்கப்பட வேண்டும். அசல் மதிப்பெண் சான்றிதழை விண்ணப்பத்துடன் அனுப்பக்கூடாது. சான்றளிக்கப்பட்ட நகல் மட்டும் இணைக்கவும்.",
  preferredCourseNote:
    "நீங்கள் படிக்க விரும்பும் பாடப்பிரிவுகளை முன்னுரிமை வரிசையில் குறிப்பிடவும்.",
  parentGuardianPledge: "பெற்றோர் / பாதுகாவலர் உறுதிமொழி",
  pledgeLine1:
    "மேலே குறிப்பிட்டுள்ள விவரங்கள் என் அறிவிற்கு எட்டியவரை உண்மையானவை மற்றும் சரியானவை என்று இதன் மூலம் அறிவிக்கிறேன், மேலும் பள்ளியின் விதிகள் மற்றும் ஒழுங்குகளை நான் கடைப்பிடிப்பேன்.",
  pledgeLine2:
    "தவறான தகவல்கள் அல்லது உண்மைகளை மறைத்து சேர்க்கை பெறப்பட்டதாக கண்டறியப்பட்டால், அது எந்த நேரத்திலும் ரத்து செய்யப்படலாம் என்பது எனக்குத் தெரியும்.",
  pledgeLine3:
    "பள்ளி ஒழுக்கத்தை பின்பற்றுவேன், எந்த மீறலிலும் மாற்றுச் சான்றிதழ் பெற விண்ணப்பிக்க ஒப்புக்கொள்கிறேன்.",
  pledgeNote: "குறிப்பு:",
  pledgeNote1:
    "சேர்க்கையின் போது அசல்களை சமர்ப்பித்து நகல்களை வைத்திருக்கவும்.",
  pledgeNote2:
    "மாணவர் பள்ளி விட்ட பிறகு சான்றிதழ்கள் திரும்ப வழங்கப்பட மாட்டாது.",
  instructions: "அறிவுறுத்தல்கள்",
  feedbackRecordedFor:
    "இந்த கருத்து {count} மாணவர்(களுக்கு) பதிவு செய்யப்படும்.",
  areYouSure: "நீங்கள் உறுதியாக இருக்கிறீர்களா?",
  confirmStatusChange:
    "நீங்கள் உறுதியாக இருக்கிறீர்களா? நிலையை '{from}' இலிருந்து '{to}' ஆக மாற்ற விரும்புகிறீர்களா?",
  seatAllocateConfirm:
    "ஒரு நேரத்தில் ஒருமுறை மட்டுமே இருக்கை ஒதுக்க முடியும். தொடர விரும்புகிறீர்களா?",
  moveToDroppedConfirm: "நீக்கப்பட்டதாக மாற்ற விரும்புகிறீர்களா?",
  studyMaterialGeneratedCancelConfirm:
    "படிப்புப் பொருள் உருவாக்கப்பட்டுள்ளது. நீங்கள் ரத்து செய்து அதை நீக்க உறுதியாக விரும்புகிறீர்களா?",

  // ==================== Placeholder Labels ====================
  eventPlaceholder: "[TRANSLATE]: Select Event section",
  venuePlaceholder: "[TRANSLATE]: Enter venue",
  descriptionPlaceholder: "[TRANSLATE]: Enter description",
  shortDescriptionPlaceholder: "[TRANSLATE]: Enter short description",
  schoolPlaceholder: "[TRANSLATE]: Enter School",
  oldPasswordPlaceholder: "பழைய கடவுச்சொல்லை உள்ளிடவும்",
  newPasswordPlaceholder: "புதிய கடவுச்சொல்லை உள்ளிடவும்",
  confirmPasswordPlaceholder: "புதிய கடவுச்சொல்லை உறுதிப்படுத்த உள்ளிடவும்",
  selectLanguage: "மொழியை தேர்வு செய்யவும்",
  selectMaritalStatus: "திருமண நிலையை தேர்வு செய்யவும்",
  spouseNamePlaceholder: "எ.கா. வாழ்க்கைத்துணை பெயர்",
  fatherNamePlaceholder: "எ.கா. தந்தை பெயர்",
  motherNamePlaceholder: "எ.கா. தாய் பெயர்",
  selectAdmissionType: "சேர்க்கை வகையைத் தேர்ந்தெடுக்கவும்",
  selectSchoolPlaceholder: "பள்ளியை தேர்வு செய்யவும்",
  messagePlaceholder: "செய்தியை உள்ளிடவும்",
  selectAcademicYear: "கல்வி ஆண்டை தேர்வு செய்யவும்",
  selectDate: "தேதியைத் தேர்ந்தெடுக்கவும்",
  startYearPlaceholder: "எ.கா. 2025",
  endYearPlaceholder: "எ.கா. 2026",
  subjectPlaceholder: "பொருளை உள்ளிடவும்",
  grouPlaceholder: "[TRANSLATE]: Select group name",
  classPlaceholder: "[TRANSLATE]: Select Class",
  sectionPlaceholder: "[TRANSLATE]: Select Section",
  shiftPlaceholder: "[TRANSLATE]: Select Shift",
  selectsubjectPlaceholder: "பாடத்தை தேர்வு செய்யவும்",
  periodSubjectPlaceholder: "[TRANSLATE]: Period Subject",
  selectMonth: "மாதத்தை தேர்வு செய்யவும்",
  firstNamePlaceholder: "எ.கா. முதல் பெயர்",
  middleNamePlaceholder: "எ.கா. நடுத்தர பெயர்",
  lastNamePlaceholder: "எ.கா. கடைசி பெயர்",
  rollIdPlaceholder: "எ.கா. 10102004001",
  emailPlaceholder: "எ.கா. student@gmail.com",
  fatherEmailPlaceholder: "எ.கா. father@gmail.com",
  motherEmailPlaceholder: "எ.கா. mother@gmail.com",
  guardianEmailPlaceholder: "எ.கா. guardian@gmail.com",
  emailAddressPlaceholder: "எ.கா. மின்னஞ்சல் முகவரி",
  emailAltPlaceholder: "எ.கா. மின்னஞ்சல்",
  dateOfBirthPlaceholder: "எ.கா: 30/07/2016",
  aadharNumberPlaceholder: "எ.கா. ஆதார் எண்",
  aadharNumberAltPlaceholder: "எ.கா: 43215678907",
  selectGender: "பாலினத்தைத் தேர்ந்தெடுக்கவும்",
  selectClass: "வகுப்பைத் தேர்ந்தெடுக்கவும்",
  selectSection: "பிரிவைத் தேர்ந்தெடுக்கவும்",
  selectReligion: "மதத்தைத் தேர்ந்தெடுக்கவும்",
  selectCategory: "பிரிவைத் தேர்ந்தெடுக்கவும்",
  selectBloodGroup: "இரத்த வகையைத் தேர்ந்தெடுக்கவும்",
  medicalConditionPlaceholder: "எ.கா. மருத்துவ நிலை",
  photoPlaceholder: "எ.கா. Mypic.jpg",
  phoneNumberPlaceholder: "எ.கா. தொலைபேசி எண்",
  phoneNoPlaceholder: "எ.கா. தொலைபேசி எண்",
  mobileNumberPlaceholder: "எ.கா. மொபைல் எண்",
  panNumberPlaceholder: "எ.கா: 678909XYZ",
  addressPlaceholder: "எ.கா. முகவரி",
  pincodePlaceholder: "எ.கா. அஞ்சல் குறியீடு",
  cityPlaceholder: "எ.கா. நகரம்",
  selectCountry: "நாட்டைத் தேர்ந்தெடுக்கவும்",
  selectState: "மாநிலத்தைத் தேர்ந்தெடுக்கவும்",
  selectOccupation: "தொழிலைத் தேர்ந்தெடுக்கவும்",
  selectIncome: "வருமானத்தைத் தேர்ந்தெடுக்கவும்",
  selectRelation: "உறவைத் தேர்ந்தெடுக்கவும்",
  hospitalPlaceholder: "எ.கா. மருத்துவமனை",
  examNamePlaceholder: "எ.கா. அரையாண்டு தேர்வு",
  selectExamName: "தேர்வு பெயரை தேர்வு செய்யவும்",
  startDatePlaceholder: "எ.கா: 30/07/2024",
  endDatePlaceholder: "எ.கா: 30/08/2024",
  selectModeOfExam: "முறையைத் தேர்ந்தெடுக்கவும்",
  selectChild: "குழந்தையை தேர்வு செய்யவும்",
  selectReason: "காரணத்தை தேர்வு செய்யவும்",
  notePlaceholder: "எ.கா. உங்கள் செய்தியை உள்ளிடவும்",
  selectStatus: "நிலையை தேர்வு செய்யவும்",
  selectLeaveType: "விடுமுறை வகையை தேர்வு செய்யவும்",
  enterYourMessages: "எ.கா. உங்கள் செய்தியை உள்ளிடவும்",
  selectType: "வகையைத் தேர்ந்தெடுக்கவும்",
  enterHere: "இங்கே உள்ளிடவும்..",
  studentNameTamilPlaceholder: "தமிழில் மாணவர் பெயரை உள்ளிடவும்",
  studentNameEnglishPlaceholder: "ஆங்கிலத்தில் மாணவர் பெயரை உள்ளிடவும்",
  dobInWordsPlaceholder: "எ.கா. இருபத்தாறாம் டிசம்பர்...",
  castePlaceholder: "எ.கா. சாதி",
  nationalityPlaceholder: "எ.கா. இந்தியர்",
  annualIncomePlaceholder: "எ.கா., 250000",
  districtPlaceholder: "எ.கா. மாவட்டம்",
  emisNoPlaceholder: "எ.கா. 1212121212",
  selectPreferredClass: "விருப்பமான வகுப்பைத் தேர்ந்தெடுக்கவும்",
  selectMotherTongue: "தாய்மொழியைத் தேர்ந்தெடுக்கவும்",
  selectYear: "ஆண்டை தேர்வு செய்யவும்",
  birthPlacePlaceholder: "எ.கா. சென்னை",
  selectExamination: "தேர்வை தேர்வு செய்யவும்",
  selectCoursePrefered: "விரும்பும் பாடப்பிரிவை தேர்வு செய்யவும்",
  selectPreferredGroup1: "விரும்பிய குழு 1 தேர்வு செய்யவும்",
  selectPreferredGroup2: "விரும்பிய குழு 2 தேர்வு செய்யவும்",
  selectPreferredGroup3: "விரும்பிய குழு 3 தேர்வு செய்யவும்",
  reasonForLeavingPlaceholder: "பள்ளி விட்ட காரணத்தை உள்ளிடவும்",
  talukPlaceholder: "எ.கா. வட்டம்",
  groupPlaceholder: "எ.கா. குழு A",
  feedbackRemarksPlaceholder: "கருத்து / குறிப்புகளை உள்ளிடவும்",
  shiftNamePlaceholder: "ஷிப்ட் பெயரை உள்ளிடவும் (உதா: காலை ஷிப்ட்)",
  numberOfBreaksPlaceholder: "இடைவேளைகள் எண்ணிக்கையை உள்ளிடவும் (0-10)",
  numberOfPeriodsPlaceholder: "பீரியட்களின் எண்ணிக்கையை உள்ளிடவும் (1-20)",
  breakTypePlaceholder: "இடைவேளை வகையை உள்ளிடவும் (உதா: மதிய உணவு)",
  periodNamePlaceholder: "பீரியட் பெயரை உள்ளிடவும்",
  selectTopicToView: "பார்க்க ஒரு தலைப்பைத் தேர்வு செய்யவும்",
  selectMedium: "மொழி வழியை தேர்வு செய்யவும்",
  selectTerm: "பருவத்தை தேர்வு செய்யவும்",
  selectVolume: "தொகுதியை தேர்வு செய்யவும்",
  enterContentStartPage: "உள்ளடக்க தொடக்க பக்கத்தை உள்ளிடவும்",
  enterContentEndPage: "உள்ளடக்க முடிவு பக்கத்தை உள்ளிடவும்",
  enterBookPDFNumber: "புத்தக PDF எண்ணை உள்ளிடவும்",
  selectClassFirst: "முதலில் வகுப்பைத் தேர்ந்தெடுக்கவும்",
  selectBook: "புத்தகத்தைத் தேர்ந்தெடு",
  selectTopicPlaceholder: "தலைப்பைத் தேர்ந்தெடு",
  selectSubTopic: "உட்தலைப்பைத் தேர்ந்தெடு",
  enterStartPage: "தொடக்கப் பக்கத்தை உள்ளிடவும்",
  enterEndPage: "முடிவுப் பக்கத்தை உள்ளிடவும்",
  lessonPlanEditorPlaceholder: "உருவாக்கப்பட்ட பாடத் திட்டம் இங்கே தோன்றும்...",
  selectDifficulty: "சிரம நிலையை தேர்வு செய்யவும்",
  enterOptionsCount: "விருப்பங்கள் எண்ணிக்கையை உள்ளிடவும்",
  selectPassPercentage: "தேர்வு செய்யவும்",
  enterNumberOfQuestions: "கேள்விகளின் எண்ணிக்கையை உள்ளிடவும்",
  selectBookFirst: "முதலில் புத்தகத்தைத் தேர்ந்தெடுக்கவும்",
  selectTopicFirst: "முதலில் தலைப்பைத் தேர்ந்தெடுக்கவும்",

  // ==================== Validation Labels ====================
  markSheetRequired: "மதிப்பெண் பட்டியல் தேவை",
  isActiveRequired: "நிலை தேவை",
  nameRequired: "பெயர் தேவை",
  dateRequired: "தேதி தேவை",
  dateMustBeTodayOrFuture: "தேதி இன்று அல்லது எதிர்கால தேதியாக இருக்க வேண்டும்",
  fromTimeRequired: "தொடக்க நேரம் தேவை",
  toTimeRequired: "முடிவு நேரம் தேவை",
  toTimeMustBeAfterFromTime:
    "முடிவு நேரம் தொடக்க நேரத்திற்குப் பிறகு இருக்க வேண்டும்",
  venueRequired: "நிகழ்வு இடம் தேவை",
  selectAtLeastOneStudent:
    "இருக்கை ஒதுக்கப்பட்ட விண்ணப்ப பட்டியலிலிருந்து குறைந்தபட்சம் ஒரு மாணவரையாவது தேர்ந்தெடுக்கவும்",
  firstNameRequired: "முதல் பெயர் தேவை",
  lastNameRequired: "கடைசி பெயர் தேவை",
  fatherNameRequired: "தந்தை பெயர் தேவை",
  mobileNumberRequired: "மொபைல் எண் தேவை",
  mobileNumberInvalid: "சரியான 10 இலக்க மொபைல் எண்ணை உள்ளிடவும்",
  bloodGroupRequired: "இரத்த வகை தேவை",
  genderRequired: "பாலினம் தேவை",
  aadharNumberInvalid: "சரியான 12 இலக்க ஆதார் எண்ணை உள்ளிடவும்",
  dateOfBirthRequired: "பிறந்த தேதி தேவை",
  pincodeRequired: "அஞ்சல் குறியீடு தேவை",
  pincodeInvalid: "சரியான 6 இலக்க அஞ்சல் குறியீட்டை உள்ளிடவும்",
  addressRequired: "முகவரி தேவை",
  cityRequired: "நகரம் தேவை",
  stateRequired: "மாநிலம் தேவை",
  countryRequired: "நாடு தேவை",
  languageRequired: "மொழி தேவை",
  incomeRequired: "வருமானம் தேவை",
  maritalStatusRequired: "திருமண நிலை தேவை",
  anniversaryRequired: "திருமண நாள் தேவை",
  spouseNameRequired: "வாழ்க்கைத்துணை பெயர் தேவை",
  staffTypeRequired: "ஊழியர் வகை தேவை",
  studentRequired: "மாணவர் தேவை",
  teacherRequired: "ஆசிரியர் தேவை",
  onlyImageFilesAllowed:
    "jpg, jpeg, png, gif கோப்புகள் மட்டுமே அனுமதிக்கப்படும்",
  schoolRequired: "பள்ளி தேவை",
  roleRequired: "பங்கு தேவை",
  subjectRequired: "பொருள் தேவை",
  messageRequired: "செய்தி தேவை",
  startYearRequired: "தொடக்க ஆண்டு தேவை",
  startYearInvalid: "சரியான ஆண்டை உள்ளிடவும் (எ.கா., 2025)",
  endYearRequired: "முடிவு ஆண்டு தேவை",
  endYearInvalid: "சரியான ஆண்டை உள்ளிடவும் (எ.கா., 2026)",
  endYearGreater: "முடிவு ஆண்டு தொடக்க ஆண்டை விட அதிகமாக இருக்க வேண்டும்",
  fromDateRequired: "தொடக்க தேதி தேவை",
  fromDateYearMismatch: "தொடக்க தேதி தொடக்க ஆண்டுடன் பொருந்த வேண்டும்",
  toDateRequired: "முடிவு தேதி தேவை",
  toDateYearMismatch: "முடிவு தேதி முடிவு ஆண்டுடன் பொருந்த வேண்டும்",
  toDateAfter: "முடிவு தேதி தொடக்க தேதிக்குப் பிறகு இருக்க வேண்டும்",
  isUpcomingYearRequired: "இது வரவிருக்கும் ஆண்டா என்பது தேவை",
  selectAllStudentsToVerify:
    "சரிபார்க்க அனைத்து மாணவர்களையும் தேர்வு செய்யவும்.",
  panNumberInvalid: "சரியான PAN எண்ணை உள்ளிடவும் (உதா: ABCDE1234F)",
  examTypeRequired: "தேர்வு வகை தேவை",
  examNameRequired: "தேர்வு பெயர் தேவை",
  startDateRequired: "தொடக்க தேதி தேவை",
  endDateRequired: "முடிவு தேதி தேவை",
  endDateAfterStart: "முடிவு தேதி தொடக்க தேதிக்கு பிறகு இருக்க வேண்டும்",
  passRulesRequired:
    "குறைந்தபட்சம் ஒரு தேர்ச்சி விதி தேர்ந்தெடுக்கப்பட வேண்டும்",
  classRequired: "வகுப்பு தேவை",
  sectionRequired: "பிரிவு தேவை",
  includeAtLeastOneSubject: "குறைந்தபட்சம் ஒரு பாடத்தை சேர்க்கவும்",
  fillRequiredSubjectFields:
    "சேர்க்கப்பட்ட அனைத்து பாடங்களுக்கும் தேர்வு தேதி, தொடக்க நேரம் மற்றும் முடிவு நேரம் நிரப்பவும்",
  selectCategoryFirst: "முதலில் ஒரு வகையை தேர்வு செய்யவும்",
  modeOfExamRequired: "தேர்வு முறை தேவை",
  pleaseSelectExcelFile: "பதிவேற்ற ஒரு எக்செல் கோப்பைத் தேர்ந்தெடுக்கவும்.",
  onlyExcelFilesAllowed: "எக்செல் கோப்புகள் (.xlsx) மட்டுமே அனுமதிக்கப்படும்",
  selectAllFilters: "வகுப்பு, பிரிவு மற்றும் தேர்வு பெயரை தேர்வு செய்யவும்",
  childRequired: "குழந்தை தேவை",
  toDateAfterFrom: "முடிவு தேதி தொடக்க தேதிக்கு பிறகு இருக்க வேண்டும்",
  reasonRequired: "காரணம் தேவை",
  noteRequired: "குறிப்பு தேவை",
  remarkRequired:
    "ஒரு செயலைத் தேர்ந்தெடுக்கவும் (ஒப்புதல் / நிராகரி / மருத்துவச் சான்றிதழ் இணைக்கவும்)",
  holidayTypeRequired: "விடுமுறை வகை தேவை",
  toDateAfterOrSameAsFrom:
    "முடிவு தேதி தொடக்க தேதிக்கு பிறகு அல்லது அதே நாளாக இருக்க வேண்டும்",
  descriptionRequired: "விளக்கம் தேவை",
  toDateCannotBeBeforeFrom:
    "முடிவு தேதி தொடக்க தேதிக்கு முன்பு இருக்க முடியாது",
  admissionTypeRequired: "சேர்க்கை வகை தேவை",
  admissionNameRequired: "சேர்க்கை பெயர் தேவை",
  admissionStartDateRequired: "சேர்க்கை தொடக்க தேதி தேவை",
  admissionEndDateRequired: "சேர்க்கை முடிவு தேதி தேவை",
  screeningStartDateRequired: "திரையிடல் தொடக்க தேதி தேவை",
  screeningEndDateRequired: "திரையிடல் முடிவு தேதி தேவை",
  interviewStartDateRequired: "நேர்காணல் தொடக்க தேதி தேவை",
  interviewEndDateRequired: "நேர்காணல் முடிவு தேதி தேவை",
  completionDateRequired: "நிறைவு தேதி தேவை",
  studentNameTamilRequired: "மாணவர் பெயர் (தமிழ்) தேவை",
  studentNameEnglishRequired: "மாணவர் பெயர் (ஆங்கிலம்) தேவை",
  dobInWordsRequired: "பிறந்த தேதி வார்த்தைகளில் தேவை",
  emailRequired: "மின்னஞ்சல் தேவை",
  emailInvalid: "சரியான மின்னஞ்சல் முகவரியை உள்ளிடவும்",
  casteRequired: "சாதி தேவை",
  nationalityRequired: "தேசியம் தேவை",
  religionRequired: "மதம் தேவை",
  categoryRequired: "பிரிவு தேவை",
  lastStudiedMediumRequired: "கடைசியாக படித்த மொழி வழி தேவை",
  preferredMediumRequired: "விருப்பமான மொழி வழி தேவை",
  livingWithRequired: "இந்த புலம் தேவை",
  onlyNumbersAllowed: "எண்கள் மட்டுமே அனுமதிக்கப்படும்.",
  districtRequired: "மாவட்டம் தேவை",
  parentNameRequired: "பெயர் தேவை",
  guardianNameRequired: "பெயர் தேவை",
  occupationRequired: "தொழில் தேவை",
  emisNoInvalid: "சரியான EMIS எண்ணை உள்ளிடவும்",
  documentRequired: "ஆவணம் தேவை",
  allowedPdfJpgPng: "அனுமதிக்கப்படுவது: PDF/JPG/PNG.",
  lastStudiedClassRequired: "கடைசியாக படித்த வகுப்பு தேவை",
  lastStudiedSchoolRequired: "கடைசியாக படித்த பள்ளி தேவை",
  preferredClassRequired: "சேர்க்கைக்கான விருப்பமான வகுப்பு தேவை",
  motherTongueRequired: "தாய்மொழி தேவை",
  preferredFirstLanguageRequired: "படிக்க விரும்பும் முதல் மொழி தேவை",
  schoolNameRequired: "பள்ளி பெயர் தேவை",
  yearOfStudyRequired: "படிப்பு ஆண்டு தேவை",
  identificationMark1Required: "அடையாளக் குறி 1 தேவை",
  identificationMark2Required: "அடையாளக் குறி 2 தேவை",
  placeRequired: "இடம் தேவை",
  studentImageRequired: "மாணவர் படம் தேவை",
  allowedJpgPng: "அனுமதிக்கப்படுவது: JPG/PNG படங்கள்.",
  otpRequired: "OTP தேவை",
  otpInvalid: "சரியான 6 இலக்க OTP ஐ உள்ளிடவும்",
  reasonForWithdrawRequired: "திரும்பப் பெற காரணம் தேவை",
  feedbackRequired: "கருத்து தேவை",
  birthPlaceRequired: "பிறந்த இடம் தேவை",
  communityCertificateRequired: "சமுதாய சான்றிதழ் தேவை",
  onlyTamilAllowed: "தமிழ் எழுத்துக்கள் மட்டுமே உள்ளிடவும்",
  qualifyingExamRequired: "தகுதித் தேர்வு தேவை",
  examBoardRequired: "தேர்வு வாரியம் தேவை",
  qualifiedExamRequired: "தேர்ச்சி பெற்ற தேர்வின் பெயர் தேவை",
  examMonthYearRequired: "மாதம் மற்றும் ஆண்டு தேவை",
  registerNumberRequired: "பதிவு எண் தேவை",
  preferredStudyCourseRequired: "படிக்க விரும்பும் பாடப்பிரிவு தேவை",
  yearOfAdmissionRequired: "சேர்க்கை ஆண்டு தேவை",
  preferredGroup1Required: "விரும்பிய குழு 1 தேவை",
  mediumLeavingSchoolRequired: "கற்பித்தல் மொழி வழி தேவை",
  studiedYearRequired: "படிப்பு ஆண்டு தேவை",
  reasonForLeavingRequired: "பள்ளி விட்ட காரணம் தேவை",
  lastStudiedSchoolNameRequired: "கடைசியாக படித்த பள்ளியின் பெயர் தேவை",
  emisNoRequired: "EMIS எண் தேவை",
  talukRequired: "வட்டம் தேவை",
  noStudentsSelected: "மாணவர்கள் எவரும் தேர்வு செய்யப்படவில்லை",
  shiftNameRequired: "ஷிப்ட் பெயர் அவசியம்",
  shiftTimeInvalid: "முடிவு நேரம் தொடக்க நேரத்தை விட பின்பு இருக்க வேண்டும்",
  periodsRequired: "பீரியட்களின் எண்ணிக்கை அவசியம்",
  periodsMin: "பீரியட்களின் எண்ணிக்கை 0-க்கு மேல் இருக்க வேண்டும்",
  periodsMax: "பீரியட்களின் எண்ணிக்கை 20-ஐ மீறக்கூடாது",
  breaksRequired: "இடைவேளைகளின் எண்ணிக்கை அவசியம்",
  breaksMin: "இடைவேளைகள் 0-க்கும் குறைவாக இருக்கக்கூடாது",
  breaksMax: "இடைவேளைகள் 10-ஐ மீறக்கூடாது",
  typeRequired: "வகை அவசியம்",
  startTimeRequired: "தொடக்க நேரம் அவசியம்",
  endTimeRequired: "முடிவு நேரம் அவசியம்",
  endAfterStart: "முடிவு நேரம் தொடக்க நேரத்திற்குப் பிறகு இருக்க வேண்டும்",
  withinShift: "ஷிப்ட் நேரத்திற்குள் இருக்க வேண்டும்",
  overlapWith: "மோதுகிறது",
  subjectMediumRequired: "பாட மொழி தேவை",
  onlyPdfFilesAllowed: "PDF கோப்புகள் மட்டுமே அனுமதிக்கப்படும்",
  fileNameMismatch: "கோப்பு பெயர் தேர்ந்தெடுக்கப்பட்டவற்றுடன் பொருந்தவில்லை",
  expectedFileName: "எதிர்பார்க்கப்படும் கோப்பு பெயர் வடிவம்",
  contentStartPageRequired: "உள்ளடக்க தொடக்க பக்கம் தேவை",
  contentEndPageRequired: "உள்ளடக்க முடிவு பக்கம் தேவை",
  bookFirstPageNoRequired: "புத்தக முதல் பக்க எண் தேவை",
  pdfPageOfBookFirstPageNoRequired: "புத்தக முதல் பக்க PDF பக்க எண் தேவை",
  contentEndPageMustBeAfterStart:
    "உள்ளடக்க முடிவு பக்கம் தொடக்க பக்கத்தை விட அதிகமாகவோ அல்லது சமமாகவோ இருக்க வேண்டும்",
  bookFirstPageNoMin:
    "புத்தக முதல் பக்க எண் குறைந்தபட்சம் 1 ஆக இருக்க வேண்டும்",
  pdfPageNoMin:
    "புத்தக முதல் பக்க PDF பக்க எண் குறைந்தபட்சம் 1 ஆக இருக்க வேண்டும்",
  bookRequired: "புத்தகம் தேவை",
  topicRequired: "தலைப்பு தேவை",
  startPageRequired: "தொடக்கப் பக்கம் தேவை",
  timeDurationRequired: "நேர அளவு தேவை",
  endPageRequired: "முடிவுப் பக்கம் தேவை",
  scheduleDateRequired: "அட்டவணை தேதி தேவை",
  pageBetween: "இடையே இருக்க வேண்டும்",
  pageValueBetween: "மதிப்பு இடையே இருக்க வேண்டும்",
  endPageAfterStart:
    "முடிவுப் பக்கம் தொடக்கப் பக்கத்தை விட அதிகமாகவோ அல்லது சமமாகவோ இருக்க வேண்டும்",
  invalidSubjectSelection:
    "ஒரே பாடம் உள்ள காலங்களை மட்டுமே தேர்வு செய்ய முடியும்",
  invalidClassSelection:
    "ஒரே வகுப்பு உள்ள காலங்களை மட்டுமே தேர்வு செய்ய முடியும்",
  selectAtLeastOneCell:
    "அட்டவணைப்படுத்த குறைந்தது ஒரு காலத்தையாவது தேர்வு செய்யவும்",
  invalidCellStatusSelection:
    "ஏற்கனவே சமர்ப்பிக்கப்பட்ட, அங்கீகரிக்கப்பட்ட, நிராகரிக்கப்பட்ட, மீண்டும் சமர்ப்பிக்கப்பட்ட அல்லது முடிக்கப்பட்ட காலத்தை நிரப்ப முடியாது.",
  selectTimetableCellFirst:
    "பாடத் திட்டத்தைத் தேர்வு செய்வதற்கு முன் நேர அட்டவணை கட்டத்தைத் தேர்வு செய்யவும்.",
  selectLessonPlanFirst:
    "சமர்ப்பிப்பதற்கு முன் ஒரு பாடத் திட்டத்தைத் தேர்வு செய்யவும்.",
  selectRowToDelete: "நீக்க ஒரு வரிசையைத் தேர்ந்தெடுக்கவும்",
  numQuestionsRequired: "கேள்விகளின் எண்ணிக்கை தேவை",
  maxQuestionsAllowed: "அதிகபட்சம் 10 கேள்விகள் அனுமதிக்கப்படும்",
  minQuestionRequired: "குறைந்தபட்சம் 1 கேள்வி தேவை",
  difficultyLevelRequired: "சிரம நிலை தேவை",
  mcqOptionsRequired: "MCQ விருப்பங்கள் எண்ணிக்கை தேவை",
  passPercentageRequired: "தேர்ச்சி சதவீதம் தேவை",
  subTopicRequired: "உட்தலைப்பு தேவை",
  endPageGreaterStart:
    "முடிவு பக்கம் தொடக்க பக்கத்தை விட அதிகமாக இருக்க வேண்டும்",
  startPageMin: "தொடக்க பக்கம் இதற்கு சமமாகவோ அதிகமாகவோ இருக்க வேண்டும் >=",
  endPageMax: "முடிவு பக்கம் இதற்கு சமமாகவோ குறைவாகவோ இருக்க வேண்டும் <=",

  // ==================== Error Labels ====================
  unableToLoadData: "தரவை ஏற்ற முடியவில்லை. பின்னர் மீண்டும் முயற்சிக்கவும்.",
  interviewSaveFailed: "நேர்காணல் அட்டவணையைச் சேமிக்க முடியவில்லை.",
  profileUpdateFailed:
    "சுயவிவரத்தை புதுப்பிக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
  noSentMessagesFound: "அனுப்பிய செய்திகள் எதுவும் இல்லை",
  noMessagesFound: "செய்திகள் எதுவும் இல்லை",
  fileUploadFailed: "கோப்பை பதிவேற்ற முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
  academicSaveFailed:
    "கல்வி ஆண்டு அமைப்பைச் சேமிக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
  somethingWrong: "ஏதோ தவறு ஏற்பட்டது!",
  noExamResultFound: "இந்த வகுப்பிற்கு தேர்வு முடிவு எதுவும் இல்லை.",
  noRecordsToDisplay: "காட்ட பதிவுகள் இல்லை",
  failedToDownload: "மாணவர் பட்டியலை பதிவிறக்க முடியவில்லை",
  saveFailed: "சேமிக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
  fetchFailed: "விவரங்களை பெற முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
  deleteFailed: "நீக்க முடியவில்லை.",
  bulkUploadFailed: "கோப்பை பதிவேற்ற முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
  markBulkUploadFailed:
    "மதிப்பெண்களை பதிவேற்ற முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
  marksAlreadyExist: "மதிப்பெண்கள் ஏற்கனவே உள்ளன",  downloadFailed:
    "எக்செல் பதிவிறக்கம் தோல்வியடைந்தது. மீண்டும் முயற்சிக்கவும்.",
  publishFailed: "முடிவை வெளியிட முடியவில்லை.",
  studentsFailed: "தோல்வியடைந்த மாணவர்கள்",
  noStudentsFound: "மாணவர்கள் எவரும் இல்லை",
  attendanceSaveFailed: "வருகை சேமிக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
  leaveSaveFailed:
    "விடுப்பு கோரிக்கையை சேமிக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
  leaveApprovalFailed:
    "விடுப்பு நிலையை புதுப்பிக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
  holidaySaveFailed: "விடுமுறையை சேமிக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
  holidayFetchFailed:
    "விடுமுறை விவரங்களை பெற முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
  error: "தரவை ஏற்றுவதில் பிழை",
  studentFailed: "தோல்வியடைந்த மாணவர்கள்",
  updateFailed: "புதுப்பிக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
  bulkStatusChangeFailed:
    "நிலையை புதுப்பிக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
  checklistUpdateFailed: "சரிபார்ப்பு பட்டியல் புதுப்பிக்க முடியவில்லை",
  somethingWentWrongTryAgain: "ஏதோ தவறு ஏற்பட்டது. மீண்டும் முயற்சிக்கவும்.",
  somethingWentWrong: "ஏதோ தவறு ஏற்பட்டது",
  failedToLoadPdf: "PDF ஏற்ற முடியவில்லை",
  noHistoryFound: "வரலாறு எதுவும் இல்லை",
  noSavedLessonPlans: "சேமிக்கப்பட்ட பாடத் திட்டங்கள் எதுவும் இல்லை",
  failedToLoadLessonPlan: "பாடத் திட்டத்தை ஏற்ற முடியவில்லை",
  somethingWentWrongGenerate: "பாடத் திட்டத்தை உருவாக்கும்போது பிழை ஏற்பட்டது.",
  somethingWentWrongSave: "பாடத் திட்டத்தைச் சேமிக்கும்போது பிழை ஏற்பட்டது.",
  noTimetableFound: "இந்த வாரத்திற்கான கால அட்டவணை இல்லை.",
  statusUpdateFailed: "நிலை புதுப்பிப்பு தோல்வியடைந்தது",
  failedToFetchLessonPlan: "பாடத் திட்டத்தைப் பெற முடியவில்லை",
  noQuestionsGenerated: "இன்னும் கேள்விகள் உருவாக்கப்படவில்லை",
  failedToFetchAssessment: "மதிப்பீட்டு விவரங்களைப் பெற முடியவில்லை",
  noExamDataAvailable: "இன்னும் தேர்வு தரவு இல்லை",
  noAbsenteeToday: "இன்று வராதவர் யாரும் இல்லை",
  noAttendanceDataAvailable: "வருகைத் தரவு எதுவும் இல்லை",
  noDataAvailable: "தரவு எதுவும் இல்லை",

  // ==================== Notification Labels ====================
  interviewInviteSentSuccess: "நேர்காணல் அழைப்பு வெற்றிகரமாக அனுப்பப்பட்டது!",
  interviewCreateSuccess: "நேர்காணல் அட்டவணை வெற்றிகரமாக உருவாக்கப்பட்டது!",
  interviewUpdateSuccess: "நேர்காணல் அட்டவணை வெற்றிகரமாக புதுப்பிக்கப்பட்டது!",
  profileUpdateSuccess: "சுயவிவரம் வெற்றிகரமாக புதுப்பிக்கப்பட்டது!",
  messageSentSuccess: "செய்தி வெற்றிகரமாக அனுப்பப்பட்டது",
  academicCreatedSuccess: "கல்வி ஆண்டு அமைப்பு வெற்றிகரமாக உருவாக்கப்பட்டது!",
  academicUpdatedSuccess:
    "கல்வி ஆண்டு அமைப்பு வெற்றிகரமாக புதுப்பிக்கப்பட்டது!",
  createSuccess: "வெற்றிகரமாக உருவாக்கப்பட்டது!",
  updateSuccess: "வெற்றிகரமாக புதுப்பிக்கப்பட்டது!",
  deleteSuccess: "வெற்றிகரமாக நீக்கப்பட்டது!",
  bulkUploadSuccess: "கோப்பு வெற்றிகரமாக பதிவேற்றப்பட்டது!",
  markBulkUploadSuccess: "மதிப்பெண்கள் வெற்றிகரமாக பதிவேற்றப்பட்டன!",
  publishSuccess: "முடிவு வெற்றிகரமாக வெளியிடப்பட்டது!",
  attendanceSaveSuccess: "வருகை வெற்றிகரமாக சேமிக்கப்பட்டது!",
  attendanceUpdateSuccess: "வருகை வெற்றிகரமாக புதுப்பிக்கப்பட்டது!",
  leaveCreateSuccess: "விடுப்பு கோரிக்கை வெற்றிகரமாக உருவாக்கப்பட்டது!",
  leaveUpdateSuccess: "விடுப்பு வெற்றிகரமாக புதுப்பிக்கப்பட்டது!",
  leaveApprovalSuccess: "விடுப்பு நிலை வெற்றிகரமாக புதுப்பிக்கப்பட்டது!",
  holidayCreateSuccess: "விடுமுறை வெற்றிகரமாக உருவாக்கப்பட்டது!",
  holidayUpdateSuccess: "விடுமுறை வெற்றிகரமாக புதுப்பிக்கப்பட்டது!",
  bulkStatusChangeSuccess: "நிலை வெற்றிகரமாக புதுப்பிக்கப்பட்டது!",
  checklistUpdateSuccess:
    "சரிபார்ப்பு பட்டியல் வெற்றிகரமாக புதுப்பிக்கப்பட்டது",
  statusChangedSuccess: "நிலை வெற்றிகரமாக மாற்றப்பட்டது!",
  seatAllocatedSuccess: "இருக்கை வெற்றிகரமாக ஒதுக்கப்பட்டது",
  lessonPlanUpdatedSuccess: "பாடத் திட்டம் வெற்றிகரமாக புதுப்பிக்கப்பட்டது!",
  lessonPlanCreatedSuccess: "பாடத் திட்டம் வெற்றிகரமாக உருவாக்கப்பட்டது!",
  lessonPlanScheduledSuccess: "பாடத் திட்டம் வெற்றிகரமாக நிரப்பப்பட்டது",
  statusUpdateSuccess: "நிலை வெற்றிகரமாக புதுப்பிக்கப்பட்டது",
  assessmentGeneratedSuccess: "மதிப்பீடு வெற்றிகரமாக உருவாக்கப்பட்டது",
  assessmentSavedSuccess: "மதிப்பீடு வெற்றிகரமாக சேமிக்கப்பட்டது",
  copied: "நகலெடுக்கப்பட்டது!",

  // Fees Management
  feeAssign: "கட்டணம் ஒதுக்கீடு",
  feeType: "கட்டண வகை",
  feeDiscount: "கட்டண தள்ளுபடி",
  searchClassSection: "வகுப்பு & பிரிவைத் தேடுங்கள்",
  unAssignStudents: "ஒதுக்கப்படாத மாணவர்கள்",
  groupFee: "குழு கட்டணம்",
  demandDate: "தேவை தேதி",
  dueDate: "கடைசி தேதி",
  option: "விருப்பம்",
  downloading: "பதிவிறக்குகிறது...",
  createGroupFee: "குழு கட்டணம் உருவாக்கு",
  editGroupFee: "குழு கட்டணம் திருத்து",
  feeList: "கட்டணப் பட்டியல்",
  discountFeeList: "தள்ளுபடி கட்டணங்கள்",
  groupFeesConfiguration: "குழு கட்டண அமைப்பு",
  discountFeeType: "தள்ளுபடி கட்டணங்கள்",
  totalAmount: "மொத்தத் தொகை",
  totalDiscountAmount: "மொத்த தள்ளுபடி தொகை",
  fineAmount: "அபராதத் தொகை",
  enterAmount: "தொகையை உள்ளிடவும்",
  enterFineAmount: "அபராதத் தொகையை உள்ளிடவும்",
  enterGroupName: "குழு பெயரை உள்ளிடவும்",
  selectFeeType: "கட்டண வகையைத் தேர்ந்தெடுக்கவும்",
  selectOneOrMoreFeeType:
    "ஒன்று அல்லது அதற்கு மேற்பட்ட கட்டண வகையைத் தேர்ந்தெடுக்கவும்",
  selectDiscountFeeType:
    "ஒன்று அல்லது அதற்கு மேற்பட்ட தள்ளுபடியைத் தேர்ந்தெடுக்கவும்",
  enterDescriptionMaxWords: "விளக்கத்தை உள்ளிடவும் (அதிகபட்சம்: 100 சொற்கள்)",
  enterDescription: "விளக்கத்தை உள்ளிடவும் (அதிகபட்சம்: 100 சொற்கள்)",
  specialCharactersNotAllowed:
    "சிறப்பு எழுத்துகள் மற்றும் ஈமோஜிகள் அனுமதிக்கப்படவில்லை",
  groupNameRequired: "குழு பெயர் தேவை",
  feeTypeRequired: "கட்டண வகை தேவை",
  amountRequired: "தொகை தேவை",
  demandDateRequired: "தேவை தேதி தேவை",
  dueDateRequired: "கடைசி தேதி தேவை",
  fineAmountRequired: "அபராதத் தொகை தேவை",
  dueDateAfterDemand: "கடைசி தேதி தேவை தேதிக்குப் பிறகு இருக்க வேண்டும்",
  amount: "தொகை",
  discount: "தள்ளுபடி",
  discountAmount: "தள்ளுபடி தொகை",
  selectDiscount: "தள்ளுபடியைத் தேர்ந்தெடுக்கவும் (விருப்பத்திற்குரியது)",
  deleteGroupFee: "குழு கட்டணத்தை நீக்கு",
  groupFeeCreatedSuccess: "குழு கட்டணம் வெற்றிகரமாக உருவாக்கப்பட்டது!",
  groupFeeUpdatedSuccess: "குழு கட்டணம் வெற்றிகரமாக புதுப்பிக்கப்பட்டது!",
  groupFeeDeletedSuccess: "குழு கட்டணம் வெற்றிகரமாக நீக்கப்பட்டது!",
  confirmDeleteMessage: "நீங்கள் நிச்சயமாக நீக்க விரும்புகிறீர்களா?",
  onlyJpegPngAllowed: "jpeg, png கோப்புகள் மட்டுமே அனுமதிக்கப்படும்",

  // ── கட்டண அறிக்கைகள் ──
  searchDueFeesReport: "நிலுவைக் கட்டண அறிக்கையைத் தேடுக",
  dateRange: "தேதி வரம்பு",
  totalDemand: "மொத்தத் தேவை",
  outstanding: "நிலுவைத் தொகை",
  ofTotalDemand: "மொத்தத் தேவையில்",
  downloadAsExcel: "எக்செல் ஆக பதிவிறக்கு",
  downloadAsPdf: "PDF ஆக பதிவிறக்கு",
  emisIdAdmissionId: "எமிஸ் ஐடி / சேர்க்கை ஐடி",
  chalanNo: "சலான் எண்",
  paidAmount: "செலுத்திய தொகை (₹)",
  dueAmount: "நிலுவைத் தொகை",
  paymentMode: "கட்டண முறை",
  upiTransactionId: "UPI பரிவர்த்தனை ஐடி",
  paid: "செலுத்தப்பட்டது",
  searchByStudentNameChalanId: "மாணவர் பெயர், சலான் ஐடி மூலம் தேடுக",
  noRecordsFound: "பதிவுகள் எதுவும் இல்லை",
  dueFeesReport: "நிலுவைக் கட்டண அறிக்கை",
  discountsReport: "தள்ளுபடி அறிக்கை",
  discountCategory: "தள்ளுபடி வகை",
  selectDiscountCategory: "தள்ளுபடி வகையைத் தேர்ந்தெடுக்கவும்",
  discountCategoryWise: "தள்ளுபடி வகை வாரியாக",
  discountedAmount: "தள்ளுபடி செய்யப்பட்ட தொகை",
  studentsBenefited: "பயனடைந்த மாணவர்கள்",
  totalDiscountedAmount: "மொத்த தள்ளுபடித் தொகை",
  averageDiscount: "சராசரி தள்ளுபடி",
  perStudent: "ஒரு மாணவருக்கு",
  chartView: "வரைபடக் காட்சி",
  tableView: "அட்டவணைக் காட்சி",
  allFeesTransactionsReport: "அனைத்து கட்டணப் பரிவர்த்தனை அறிக்கை",
  regularTransaction: "வழக்கமான பரிவர்த்தனை",
  admissionTransaction: "சேர்க்கை பரிவர்த்தனை",
  selectPaymentMode: "கட்டண முறையைத் தேர்ந்தெடுக்கவும்",
  online: "ஆன்லைன்",
  cash: "ரொக்கம்",
  transactionId: "பரிவர்த்தனை ஐடி",
  emisId: "எமிஸ் ஐடி",
  admissionId: "சேர்க்கை ஐடி",
  upiReferenceId: "UPI குறிப்பு ஐடி",
  adminApprovalStatus: "நிர்வாக ஒப்புதல் நிலை",
  feesPaidStatus: "கட்டணம் செலுத்திய நிலை",
  pendingApproval: "ஒப்புதல் நிலுவையில்",
  partlyPaid: "பகுதியளவு செலுத்தப்பட்டது",
  totalTransactions: "மொத்த பரிவர்த்தனைகள்",
  totalPaidAmount: "மொத்த செலுத்திய தொகை",
  approvedTransactions: "அங்கீகரிக்கப்பட்ட பரிவர்த்தனைகள்",
  successRate: "வெற்றி",
  pendingRate: "நிலுவையில்",
};

export default ta;
